{
  "pairs": [
    {
      "alloy_a": "1060",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3105",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3106",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3107",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3108",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3109",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3110",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3111",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3112",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3113",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3114",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3115",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3116",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3117",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3118",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3119",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3120",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3121",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3122",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3123",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3124",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3125",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3126",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3127",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3128",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3132",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3133",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3134",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3135",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3136",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3137",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3046",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3047",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3048",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3049",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3050",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3051",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3052",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3053",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3056",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3057",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3060",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3061",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3062",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3063",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3064",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3065",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3066",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3067",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3068",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3069",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3070",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3144",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3145",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3146",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3147",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3148",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3149",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3150",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3151",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3152",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3153",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3154",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3155",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3156",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3157",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3159",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3160",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3161",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3072",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3073",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3074",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3075",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3076",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3077",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3078",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3079",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3080",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3082",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3083",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3084",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3085",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3086",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3087",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3088",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3089",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3090",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3091",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3162",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3163",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3164",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3165",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3166",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3167",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3168",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3169",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3170",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3171",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3092",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3093",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3094",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3095",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3096",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3172",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3173",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3174",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3175",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3176",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3177",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3178",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3179",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3180",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3181",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3182",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3183",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3184",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3185",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3186",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3187",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3188",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3189",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3190",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3192",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3193",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3194",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3195",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3196",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3197",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3198",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3199",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3200",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3201",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3202",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3203",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3204",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3205",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3206",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3207",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3208",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3209",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3210",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3211",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3212",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3213",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3214",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3215",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3216",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3217",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3218",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3219",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3220",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3221",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3222",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3223",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3224",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3225",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3226",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3227",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3228",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3229",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3230",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3231",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3232",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3233",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3234",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3235",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3236",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3237",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3238",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3239",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3240",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3241",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3242",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3243",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3244",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3245",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3246",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3247",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3248",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3249",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3250",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3251",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3252",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3253",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3254",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3255",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3097",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3098",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3099",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3100",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3101",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3102",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3103",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3104",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3256",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3257",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3258",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3259",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3058",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3059",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3129",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3130",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3131",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3138",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3139",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3140",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3141",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3142",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3143",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1060",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3054",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3055",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3319",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3320",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3321",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3322",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3323",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3324",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3325",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3326",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3327",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3328",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3329",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3330",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3331",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3332",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3333",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3334",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3336",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3337",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3338",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3339",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3340",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3341",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3342",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3343",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3347",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3348",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3349",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3350",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3260",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3261",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3262",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3263",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3264",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3265",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3266",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3267",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3270",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3271",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3274",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3275",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3276",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3277",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3278",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3279",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3280",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3281",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3282",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3283",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3284",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3285",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3358",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3359",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3360",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3361",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3362",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3363",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3364",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3365",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3366",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3367",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3368",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3369",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3370",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3371",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3372",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3373",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3374",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3375",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3286",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3287",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3288",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3289",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3290",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3291",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3292",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3294",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3295",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3296",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3297",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3298",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3299",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3301",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3302",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3303",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3304",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3305",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3376",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3377",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3378",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3379",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3380",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3381",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3382",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3383",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3384",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3306",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3307",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3308",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3309",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3310",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3386",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3387",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3388",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3389",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3390",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3391",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3392",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3393",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3394",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3395",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3396",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3397",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3398",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3399",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3400",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3401",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3402",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3403",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3404",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3405",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3406",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3407",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3408",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3409",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3410",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3412",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3413",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3414",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3415",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3416",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3417",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3418",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3419",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3420",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3421",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3422",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3424",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3425",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3426",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3427",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3428",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3429",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3430",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3431",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3432",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3433",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3434",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3435",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3436",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3437",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3438",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3439",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3440",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3441",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3442",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3443",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3444",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3445",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3446",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3447",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3448",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3449",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3450",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3451",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3452",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3453",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3454",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3455",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3456",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3457",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3458",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3459",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3460",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3461",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3462",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3463",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3464",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3465",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3466",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3467",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3468",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3469",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3311",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3312",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3313",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3314",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3315",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3316",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3317",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3318",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3470",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3471",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3472",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3473",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3272",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3273",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3344",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3345",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3346",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3352",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3353",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3354",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3355",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3356",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3357",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1070",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3268",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3533",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3534",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3535",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3536",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3537",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3538",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3539",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3540",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3541",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3542",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3543",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3544",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3545",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3546",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3547",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3548",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3549",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3550",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3551",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3552",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3553",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3554",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3555",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3556",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3560",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3561",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3562",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3563",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3564",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3565",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3474",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3475",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3476",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3477",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3478",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3479",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3480",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3481",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3484",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3485",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3488",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3489",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3490",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3491",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3492",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3493",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3494",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3495",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3496",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3497",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3498",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3499",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3572",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3573",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3574",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3575",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3576",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3577",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3578",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3579",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3580",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3581",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3582",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3583",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3584",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3585",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3586",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3587",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3588",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3589",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3500",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3501",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3502",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3503",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3504",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3505",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3506",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3507",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3508",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3509",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3510",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3511",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3512",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3513",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3514",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3515",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3516",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3517",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3518",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3519",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3590",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3591",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3592",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3593",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3594",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3595",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3596",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3597",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3598",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3599",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3520",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3521",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3522",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3523",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3524",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3600",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3601",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3602",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3603",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3604",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3605",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3606",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3607",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3608",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3609",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3610",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3611",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3612",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3613",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3614",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3615",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3616",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3617",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3618",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3619",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3620",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3621",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3622",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3623",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3624",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3625",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3626",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3627",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3628",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3629",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3630",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3631",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3632",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3633",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3634",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3635",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3636",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3637",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3638",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3639",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3640",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3641",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3642",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3643",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3644",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3645",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3646",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3647",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3648",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3650",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3651",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3652",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3653",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3654",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3655",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3656",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3657",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3658",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3659",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3660",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3661",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3662",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3663",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3664",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3665",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3666",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3667",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3668",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3669",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3670",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3671",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3672",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3673",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3674",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3675",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3676",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3677",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3678",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3679",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3680",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3681",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3682",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3683",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3525",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3526",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3527",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3528",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3529",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3530",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3531",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3532",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3684",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3685",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3686",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3687",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3486",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3487",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3557",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3558",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3559",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3566",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3567",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3568",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3569",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3570",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3571",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1080",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3482",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3483",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3747",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3748",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3749",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3750",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3751",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3752",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3753",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3754",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3755",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3756",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3757",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3758",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3759",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3760",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3761",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3762",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3763",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3764",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3765",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3766",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3767",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3768",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3769",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3774",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3775",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3776",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3777",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3778",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3779",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3688",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3689",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3690",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3691",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3692",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3693",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3694",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3695",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3698",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3699",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3702",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3703",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3704",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3705",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3706",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3707",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3708",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3709",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3710",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3711",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3712",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3713",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3786",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3787",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3788",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3789",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3790",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3791",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3792",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3793",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3794",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3795",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3796",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3797",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3798",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3799",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3800",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3801",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3802",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3803",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3714",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3715",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3716",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3717",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3718",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3719",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3720",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3721",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3722",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3723",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3724",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3725",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3726",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3727",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3728",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3729",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3730",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3731",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3732",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3733",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3804",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3805",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3806",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3807",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3808",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3809",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3810",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3811",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3812",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3734",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3735",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3736",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3737",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3738",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3814",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3815",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3816",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3817",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3818",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3819",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3820",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3821",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3822",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3823",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3824",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3825",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3826",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3827",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3828",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3829",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3830",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3831",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3832",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3833",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3834",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3835",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3836",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3837",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3838",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3839",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3840",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3841",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3842",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3843",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3844",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3845",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3846",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3847",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3848",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3849",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3850",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3851",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3852",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3853",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3854",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3855",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3857",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3858",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3859",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3860",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3861",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3862",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3863",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3864",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3865",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3866",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3867",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3868",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3869",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3870",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3871",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3872",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3873",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3874",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3875",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3876",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3877",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3878",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3879",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3880",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3881",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3882",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3883",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3884",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3885",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3886",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3887",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3888",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3889",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3890",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3891",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3892",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3893",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3894",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3895",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3896",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3897",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3739",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3740",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3741",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3742",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3743",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3744",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3745",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3746",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3898",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3899",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3900",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3901",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3700",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3701",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3771",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3772",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3773",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3780",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3781",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3782",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3783",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3784",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3785",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1100",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3696",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3697",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3961",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3962",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3963",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3964",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3965",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3966",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3967",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3968",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3969",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3970",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3971",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3972",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3973",
          "not_recommended": false
        },
        {
          "filler": "1188",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3974",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3975",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3976",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3977",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3978",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3979",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3980",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3981",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3982",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3983",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3984",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3988",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3989",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3990",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3991",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3992",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3993",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3902",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3903",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3904",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3905",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3906",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3907",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3908",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3909",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3912",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3913",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3916",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3917",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3918",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3919",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3920",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3921",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3922",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3923",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3924",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3925",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3926",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3927",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4000",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4001",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4002",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4003",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4004",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4005",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4006",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4007",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4008",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4009",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4010",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4011",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4012",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4013",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4014",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4015",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4016",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4017",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3928",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3929",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3930",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3931",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3932",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3933",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3934",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3935",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3936",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3937",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3938",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3939",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3940",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3941",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3942",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3943",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3944",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3945",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3946",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4018",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4019",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4020",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4021",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4022",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4023",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4024",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4025",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4026",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4027",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3948",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3949",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3950",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3951",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3952",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4028",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4029",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4030",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4031",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4032",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4033",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4034",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4035",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4036",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4037",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4038",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4039",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4040",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4041",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4042",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4043",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4044",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4045",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4046",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4047",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4048",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4049",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4050",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4051",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4052",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4053",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4054",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4055",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4056",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4057",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4058",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4059",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4060",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4061",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4062",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4063",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4064",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4065",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4066",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4067",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4068",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4069",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4070",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4072",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4073",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4074",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4075",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4076",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4077",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4078",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4079",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4080",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4081",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4082",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4083",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4084",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4085",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4086",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4087",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4088",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4089",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4090",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4091",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4092",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4093",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4094",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4095",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4096",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4097",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4098",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4099",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4100",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4101",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4102",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4103",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4104",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4105",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4106",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4107",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4108",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4109",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4110",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4111",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3953",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3954",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3955",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3956",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3957",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3958",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3959",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3960",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4112",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4113",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4114",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4115",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3914",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3915",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3985",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3986",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3987",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3994",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3995",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3996",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3997",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3998",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3999",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "1350",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "3910",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3911",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4157",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4159",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4160",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4161",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4162",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4163",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4164",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4165",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4166",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4167",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4168",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4169",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4170",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4171",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4172",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4173",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4174",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4175",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4176",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4177",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4180",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4116",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4117",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4118",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4119",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4120",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4121",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4122",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4123",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4124",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4125",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4126",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4127",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4131",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4132",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4135",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4136",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4137",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4138",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4139",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4140",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4141",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4142",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4143",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4144",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4145",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4146",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4147",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4182",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4183",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4184",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4185",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4186",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4148",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4149",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4150",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4151",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4187",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4188",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4152",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4189",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4190",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4191",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4192",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4193",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4194",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4195",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4197",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4198",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4199",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4201",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4202",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4203",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4204",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4205",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4206",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4207",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4208",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4209",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4210",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4211",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4212",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4213",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4214",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4215",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4216",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4217",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4218",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4153",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4154",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4155",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4156",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4219",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4220",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4133",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4134",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4178",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4179",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4181",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2014",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4128",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4129",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4130",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4262",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4263",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4264",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4265",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4266",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4267",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4268",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4270",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4271",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4272",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4273",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4275",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4276",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4277",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4278",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4279",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4280",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4281",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4285",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4221",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4222",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4223",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4224",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4225",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4226",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4227",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4228",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4229",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4230",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4231",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4232",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4236",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4237",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4240",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4241",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4242",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4243",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4244",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4245",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4246",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4247",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4248",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4249",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4250",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4251",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4252",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4287",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4288",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4289",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4290",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4291",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4253",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4254",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4255",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4256",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4292",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4293",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4257",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4294",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4295",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4296",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4297",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4298",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4299",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4300",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4301",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4302",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4303",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4304",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4305",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4306",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4307",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4308",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4309",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4310",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4311",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4312",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4313",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4314",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4315",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4316",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4317",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4318",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4319",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4320",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4321",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4322",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4323",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4258",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4259",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4260",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4261",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4324",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4238",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4239",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4283",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4286",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2036",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4233",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4234",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4235",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4367",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4368",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4369",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4370",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4371",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4372",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4373",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4374",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4375",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4376",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4377",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4378",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4379",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4380",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4381",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4382",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4383",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "4384",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4386",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4387",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4390",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4326",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4327",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4328",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4329",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4330",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4331",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4332",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4333",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4334",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4335",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4336",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4337",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4341",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4342",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4345",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4346",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4347",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4348",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4349",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4350",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4352",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4353",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4354",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4356",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4357",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4392",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4393",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4394",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4395",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4396",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4358",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4359",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4360",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4361",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4397",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4398",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4362",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4399",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4400",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4401",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4402",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4403",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4404",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4405",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4406",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4407",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4408",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4409",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4410",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4411",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4412",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4413",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4414",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4415",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4416",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4417",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4418",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4419",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4420",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4421",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4422",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4423",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4424",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4425",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4426",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4427",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4428",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4363",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4364",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4365",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4366",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4429",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4430",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4343",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4344",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4388",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4389",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4391",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "2219",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4338",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "4339",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "4340",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4483",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4484",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4485",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4486",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4487",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4488",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4489",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4490",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4491",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4492",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4493",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4494",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4495",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4496",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4497",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4498",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4499",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4500",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4501",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4502",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4503",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4504",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4505",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4506",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4510",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4511",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4512",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4513",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4514",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4515",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4431",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4432",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4433",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4434",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4435",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4436",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4437",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4438",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4441",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4443",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4444",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4445",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4446",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4447",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4448",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4449",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4522",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4523",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4524",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4525",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4526",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4527",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4528",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4529",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4530",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4531",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4532",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4533",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4534",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4535",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4536",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4537",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4538",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4539",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4450",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4451",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4452",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4453",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4454",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4455",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4456",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4457",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4458",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4459",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4460",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4461",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4462",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4463",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4464",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4465",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4466",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4467",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4468",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4469",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4540",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4541",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4542",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4543",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4544",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4545",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4546",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4547",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4548",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4549",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4470",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4471",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4472",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4473",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4474",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4550",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4551",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4552",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4553",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4554",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4555",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4556",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4557",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4558",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4559",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4560",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4561",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4562",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4563",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4564",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4565",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4566",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4567",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4568",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4569",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4570",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4571",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4572",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4573",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4574",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4575",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4576",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4577",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4578",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4579",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4580",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4582",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4583",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4584",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4585",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4586",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4587",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4588",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4589",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4590",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4591",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4592",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4593",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4594",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4595",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4596",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4597",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4598",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4599",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4600",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4601",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4602",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4603",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4604",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4605",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4606",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4607",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4608",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4609",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4610",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4611",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4612",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4613",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4614",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4615",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4616",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4617",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4618",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4619",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4620",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4621",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4622",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4623",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4624",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4625",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4626",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4627",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4628",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4629",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4630",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4631",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4632",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4633",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4475",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4476",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4477",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4478",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4479",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4480",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4481",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4482",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4634",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4635",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4636",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4637",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4442",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4507",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4508",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4509",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4516",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4517",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4518",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4519",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4520",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4521",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3003",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4439",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4440",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4901",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4902",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4903",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4904",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4905",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4906",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4907",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4908",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4909",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4910",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4911",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4912",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4913",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4914",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4915",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4916",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4917",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4918",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4919",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4920",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4921",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4922",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4923",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4924",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4925",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4926",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4927",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4928",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4929",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4930",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4931",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4932",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "4933",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4934",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4935",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4936",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4937",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4938",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4939",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "D",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4946",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4947",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4948",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4949",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4950",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4845",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4846",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4847",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4848",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4849",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4850",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4851",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4852",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4855",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4857",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4859",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4860",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4861",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4862",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4863",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4956",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4957",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4958",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4959",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4960",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4961",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4962",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4963",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4964",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4965",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4966",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4967",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4968",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4969",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4970",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4971",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4972",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4973",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4864",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4865",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4866",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4867",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4868",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4869",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4870",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4871",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4872",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4873",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4874",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4875",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4876",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4877",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4878",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4879",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4880",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4881",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4882",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4883",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4974",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4975",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4976",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4977",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4978",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4979",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4980",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4981",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4982",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4983",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4884",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4885",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4886",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4887",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4888",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4984",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4985",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4986",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4987",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4988",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4989",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4990",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4991",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4992",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4993",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4994",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4995",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4996",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4997",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4998",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4999",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5000",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5001",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5002",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5003",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5004",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5005",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5006",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5007",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5008",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5009",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5010",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5011",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5012",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5013",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5014",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5015",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5016",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5017",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5018",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5019",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5020",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5022",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5023",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5024",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5025",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5026",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5027",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5028",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5029",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5030",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5031",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5032",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5033",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5034",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5035",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5036",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5037",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5038",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5039",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5040",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5041",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5042",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5043",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5044",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5045",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5046",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5047",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5048",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5049",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5050",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5051",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5052",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5053",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5054",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5055",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5056",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5057",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5058",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5059",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5060",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5061",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5062",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5063",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5064",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5065",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5066",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5067",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5068",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5069",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5070",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5071",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5072",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5073",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5074",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5075",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4889",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4890",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4891",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4892",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4893",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4894",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4895",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4896",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4897",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4898",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4899",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4900",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5076",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5077",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5078",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5079",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5080",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4856",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4940",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4941",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4942",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4943",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4944",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4945",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "D",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4951",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4952",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4953",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4954",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4955",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "3004",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4853",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4854",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "35",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "36",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "37",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "38",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "39",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "40",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "41",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "42",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "43",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "44",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "45",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "46",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "47",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "48",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "49",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "50",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "51",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "52",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "53",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "54",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "55",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "58",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "59",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "0",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "2",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "3",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "4",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "5",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "6",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "14",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "15",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "16",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "17",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "18",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "19",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "20",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "21",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "22",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "23",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "24",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "25",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "62",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "63",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "64",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "65",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "66",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "26",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "27",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "28",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "29",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "67",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "68",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "30",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "69",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "70",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "71",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "72",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "73",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "74",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "75",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "76",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "77",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "78",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "79",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "80",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "81",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "82",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "83",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "84",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "85",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "86",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "87",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "88",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "89",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "90",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "91",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "92",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "93",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "94",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "95",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "96",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "97",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "98",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "31",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "32",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "33",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "34",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "100",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "99",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "12",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "13",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "56",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "57",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "60",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "61",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "319",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "8",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "136",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "137",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "138",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "139",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "140",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "141",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "142",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "143",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "144",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "145",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "146",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "147",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "148",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "149",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "150",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "151",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "152",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "153",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "154",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "155",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "156",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "159",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "160",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "101",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "102",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "103",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "104",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "105",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "106",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "107",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "108",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "111",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "112",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "115",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "116",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "117",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "118",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "119",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "120",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "121",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "122",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "123",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "124",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "125",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "126",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "163",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "164",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "165",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "166",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "167",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "127",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "128",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "129",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "130",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "168",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "169",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "131",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "170",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "171",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "172",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "173",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "174",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "175",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "176",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "177",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "178",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "179",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "180",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "181",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "182",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "183",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "184",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "185",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "186",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "187",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "188",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "189",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "190",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "192",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "193",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "194",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "195",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "196",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "197",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "198",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "199",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "132",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "133",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "134",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "135",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "200",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "201",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "113",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "114",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "157",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "161",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "162",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "333",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "109",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "110",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "237",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "238",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "239",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "240",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "241",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "242",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "243",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "244",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "245",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "246",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "247",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "248",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "249",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "250",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "251",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "252",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "253",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "254",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "255",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "256",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "257",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "260",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "261",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "202",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "203",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "204",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "205",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "206",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "207",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "208",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "209",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "212",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "213",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "216",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "217",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "218",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "219",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "220",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "221",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "222",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "223",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "224",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "225",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "226",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "227",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "265",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "266",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "267",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "268",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "228",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "229",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "230",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "231",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "269",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "270",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "232",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "271",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "272",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "273",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "275",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "276",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "277",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "278",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "279",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "280",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "281",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "283",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "285",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "286",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "287",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "289",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "290",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "291",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "292",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "293",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "295",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "296",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "297",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "298",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "299",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "233",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "234",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "235",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "236",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "301",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "302",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "214",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "215",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "258",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "259",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "262",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "263",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "354",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "210",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "211",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "338",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "339",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "340",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "341",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "342",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "343",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "344",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "345",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "346",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "347",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "348",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "349",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "350",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "351",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "352",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "353",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "354",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "355",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "356",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "357",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "358",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "361",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "362",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "303",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "304",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "305",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "306",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "307",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "308",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "309",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "310",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "313",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "314",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "317",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "318",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "319",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "320",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "321",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "322",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "323",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "324",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "325",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "326",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "327",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "328",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "365",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "366",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "368",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "369",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "329",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "330",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "331",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "332",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "370",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "371",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "333",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "372",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "373",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "374",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "375",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "376",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "377",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "378",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "379",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "380",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "382",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "383",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "384",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "386",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "387",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "388",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "389",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "390",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "391",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "392",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "393",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "394",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "395",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "396",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "397",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "398",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "399",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "400",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "401",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "334",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "336",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "337",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "402",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "403",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "315",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "316",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "359",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "360",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "363",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "364",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "355",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "311",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "312",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "556",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "557",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "558",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "559",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "560",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "561",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "562",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "563",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "564",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "565",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "566",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "568",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "569",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "570",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "571",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "572",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "574",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "505",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "506",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "507",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "508",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "509",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "510",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "511",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "512",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "515",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "516",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "517",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "518",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "523",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "524",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "525",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "526",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "527",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "528",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "529",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "530",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "531",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "532",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "533",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "534",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "535",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "536",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "537",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "538",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "539",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "540",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "541",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "542",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "543",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "544",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "576",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "577",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "578",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "579",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "580",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "582",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "583",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "545",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "546",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "547",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "548",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "584",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "585",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "549",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "586",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "587",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "588",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "589",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "590",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "591",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "592",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "593",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "594",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "595",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "596",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "597",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "598",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "599",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "600",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "601",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "602",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "603",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "604",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "605",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "606",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "607",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "608",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "609",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "610",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "611",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "612",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "613",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "614",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "615",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "616",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "617",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "618",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "619",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "620",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "550",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "551",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "552",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "553",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "554",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "555",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "621",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "622",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "623",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "519",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "520",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "521",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "522",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "573",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "575",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "356",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "513",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "514",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "794",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "795",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "796",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "797",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "798",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "799",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "800",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "801",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "802",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "803",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "804",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "805",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "806",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "807",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "808",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "809",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "810",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "812",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "743",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "744",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "745",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "746",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "747",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "748",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "749",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "750",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "753",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "754",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "755",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "756",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "761",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "762",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "763",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "764",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "765",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "766",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "767",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "768",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "769",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "771",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "772",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "773",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "774",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "775",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "776",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "777",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "778",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "779",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "780",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "781",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "782",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "814",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "815",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "816",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "817",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "818",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "819",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "820",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "821",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "783",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "784",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "785",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "786",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "822",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "823",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "787",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "824",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "825",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "826",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "827",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "828",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "829",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "830",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "831",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "832",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "833",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "834",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "835",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "836",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "837",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "838",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "839",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "840",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "841",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "842",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "843",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "844",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "845",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "846",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "847",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "848",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "849",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "850",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "851",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "852",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "853",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "855",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "856",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "857",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "788",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "789",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "790",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "791",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "792",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "793",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "859",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "860",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "861",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "757",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "758",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "759",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "760",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "811",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "357",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "751",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "752",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "913",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "914",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "915",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "916",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "917",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "918",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "919",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "920",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "921",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "922",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "923",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "924",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "925",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "926",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "927",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "929",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "931",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "862",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "863",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "864",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "865",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "866",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "867",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "868",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "869",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "872",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "873",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "874",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "875",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "880",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "881",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "882",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "883",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "884",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "885",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "886",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "887",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "888",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "889",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "890",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "891",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "892",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "893",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "894",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "895",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "896",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "897",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "898",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "899",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "900",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "901",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "933",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "934",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "935",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "936",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "937",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "938",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "939",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "940",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "902",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "903",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "904",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "905",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "941",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "942",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "906",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "943",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "944",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "945",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "946",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "948",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "949",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "950",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "951",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "952",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "953",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "954",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "955",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "956",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "957",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "958",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "959",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "960",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "961",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "962",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "963",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "964",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "965",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "966",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "967",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "968",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "969",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "970",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "971",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "972",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "973",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "974",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "975",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "976",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "977",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "907",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "908",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "909",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "910",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "911",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "912",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "978",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "979",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "980",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "876",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "877",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "878",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "879",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "930",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "932",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "359",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "870",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "871",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1016",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1017",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1018",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1019",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1020",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1022",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1023",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1024",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1025",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "1026",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1027",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1028",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "1029",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1030",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1031",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "1032",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1033",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1034",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1035",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1036",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1039",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1040",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "981",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "982",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "983",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "984",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "985",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "986",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "987",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "988",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "991",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "992",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "995",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "996",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "997",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "998",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1000",
          "not_recommended": false
        },
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "999",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1001",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1002",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1003",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1004",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1005",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1006",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1043",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1044",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1045",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1046",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1047",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1007",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1008",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1009",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1010",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1048",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1049",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1011",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1050",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1051",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1052",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1053",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1054",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1055",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1056",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1057",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1058",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1059",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1060",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1061",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1062",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1063",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1064",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1065",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1066",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1067",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1068",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1069",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1070",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1072",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1073",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1074",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1075",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1076",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1077",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1078",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1079",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1012",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1013",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1014",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1015",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1080",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "993",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "994",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1037",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1038",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1041",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1042",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "380",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "989",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "990",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1133",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1134",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1135",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1136",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1137",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1138",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1139",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1140",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1141",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1142",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1143",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1144",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1145",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1146",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1147",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1148",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1149",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1151",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1082",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1083",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1084",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1085",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1086",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1087",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1088",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1089",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1092",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1093",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1094",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1095",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1100",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1101",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1102",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1103",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1104",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1105",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1106",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1107",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1108",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1109",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1110",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1111",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1112",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1113",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1114",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1115",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1116",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1117",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1118",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1119",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1120",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1121",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1153",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1154",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1155",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1156",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1157",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1159",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1160",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1122",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1123",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1124",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1125",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1161",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1162",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1126",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1163",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1164",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1165",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1166",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1167",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1168",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1169",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1170",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1171",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1172",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1173",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1174",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1175",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1176",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1177",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1178",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1179",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1180",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1181",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1182",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1183",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1184",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1185",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1186",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1187",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1188",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1189",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1190",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1192",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1193",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1194",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1195",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1196",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1197",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1127",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1128",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1129",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1130",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1131",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1132",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1198",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1199",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1096",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1097",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1098",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1099",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1150",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1152",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "413",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1090",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1091",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1252",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1253",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1254",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1255",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1256",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1257",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1258",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1259",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1260",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1261",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1262",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1263",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1264",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1265",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1266",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1267",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1268",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1270",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1201",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1202",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1203",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1204",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1205",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1206",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1207",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1208",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1211",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1212",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1213",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1214",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1219",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1220",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1221",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1222",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1223",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1224",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1225",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1226",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1227",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1228",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1229",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1230",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1231",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1232",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1233",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1234",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1235",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1236",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1237",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1238",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1239",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1240",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1272",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1273",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1274",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1275",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1276",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1277",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1278",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1279",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1241",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1242",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1243",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1244",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1280",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1281",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1245",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1282",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1283",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1284",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1285",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1286",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1287",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1289",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1290",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1291",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1292",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1293",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1295",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1296",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1297",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1298",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1299",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1301",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1302",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1303",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1304",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1305",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1306",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1307",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1308",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1309",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1310",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1311",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1312",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1313",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1314",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1315",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1316",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1246",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1247",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1248",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1249",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1250",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1251",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1317",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1318",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1319",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1215",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1216",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1217",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1218",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1271",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "443",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1209",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1210",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1371",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1372",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1373",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1374",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1375",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1376",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1377",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1378",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1379",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1380",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1381",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1382",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1383",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1384",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "1385",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "1386",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1387",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1389",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1320",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1321",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1322",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1323",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1324",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1326",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1327",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1330",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1331",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1332",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1333",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1338",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1339",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1340",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1341",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1342",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1343",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1344",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1345",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1346",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1347",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1348",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1349",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1350",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1352",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1353",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1354",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1356",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1357",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1358",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1359",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1391",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1392",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1393",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1394",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1395",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1396",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1397",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1398",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1360",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1361",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1362",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1363",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1399",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1400",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1364",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1401",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1402",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1403",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1404",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1405",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1406",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1407",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1408",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1409",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1410",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1412",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1413",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1414",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1415",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1416",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1417",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1418",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1419",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1420",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1421",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1422",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1424",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1425",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1426",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1427",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1428",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1429",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1430",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1431",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1432",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1433",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1434",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1435",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1365",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1366",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1368",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1369",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1370",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1436",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1437",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1438",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "1334",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "1335",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "1336",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "1337",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1388",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1390",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "444",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "1328",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "1329",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5374",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5375",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5376",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5377",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5378",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5379",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5380",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5382",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5383",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5384",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5386",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5387",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5388",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5389",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5390",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5391",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5392",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5393",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5394",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5395",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5396",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5397",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5398",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5399",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5400",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5405",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5406",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5407",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5408",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5319",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5320",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5321",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5322",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "356",
      "options": [
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5323",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5326",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5327",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5328",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5329",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5330",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5331",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5332",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5333",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5334",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5335",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5336",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5413",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5414",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5415",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5416",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5417",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5418",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5419",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5420",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5421",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5422",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5423",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5424",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5425",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5426",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5427",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5428",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5429",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5430",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5431",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5432",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5433",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5434",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5435",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5436",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5437",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5438",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5439",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5440",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5337",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5338",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5339",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5340",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5341",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5342",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5343",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5344",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5345",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5346",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5347",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5348",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5349",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5350",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5352",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5353",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5354",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5355",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5356",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5441",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5442",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5443",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5444",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5445",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5446",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5447",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5448",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5449",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5450",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5357",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5358",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5359",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5360",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5361",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5451",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5452",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5453",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5454",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5455",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5456",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5457",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5458",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5459",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5460",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5461",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5462",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5463",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5464",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5465",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5466",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5467",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5468",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5469",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5470",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5471",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5472",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5473",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5474",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5475",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5476",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5477",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5478",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5479",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5480",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5481",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5482",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5483",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5484",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5485",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5486",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5487",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5488",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5489",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5490",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5491",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5492",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5493",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5494",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5495",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5496",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5497",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5498",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5499",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5500",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5501",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5502",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5503",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5504",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5505",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5506",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5507",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5508",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5509",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5510",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5511",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5512",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5513",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5514",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5515",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5516",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5517",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5518",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5519",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5520",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5521",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5522",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5523",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5524",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5525",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5526",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5527",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5528",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5529",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5530",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5531",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5532",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5533",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5534",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5535",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5536",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5537",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5538",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5539",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5540",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5541",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5542",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5543",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5544",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5545",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5546",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5547",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5548",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5549",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5550",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5551",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5552",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5553",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5554",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5555",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5556",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5557",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5558",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5362",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5363",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5364",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5365",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5366",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5368",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5369",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5370",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5371",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5372",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5373",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5559",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5560",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5561",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5562",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5563",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5564",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5324",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5401",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5402",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5403",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5404",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5409",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5410",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5411",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5412",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5005",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5565",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5623",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5624",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5625",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5626",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5627",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5628",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5629",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5630",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5631",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5632",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5633",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5634",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5635",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5636",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5637",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5638",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5639",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5640",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5641",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5642",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5643",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5644",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5645",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5646",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5647",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5648",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5654",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5655",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5656",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5657",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5566",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5568",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5569",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5571",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5572",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5575",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5576",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5577",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5578",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5579",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5580",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5582",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5583",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5584",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5585",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5662",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5663",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5664",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5665",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5666",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5667",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5668",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5669",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5670",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5671",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5672",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5673",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5674",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5675",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5676",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5677",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5678",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5679",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5680",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5681",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5682",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5683",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5684",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5685",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5686",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5687",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5688",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5689",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5586",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5587",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5588",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5589",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5590",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5591",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5592",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5593",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5594",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5595",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5596",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5597",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5598",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5599",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5600",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5601",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5602",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5603",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5604",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5605",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5690",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5691",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5692",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5693",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5694",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5695",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5696",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5697",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5698",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5699",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5606",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5607",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5608",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5609",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5610",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5700",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5701",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5702",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5703",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5704",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5705",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5706",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5707",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5708",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5709",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5710",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5711",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5712",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5713",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5714",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5715",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5716",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5717",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5718",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5719",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5720",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5721",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5722",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5723",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5724",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5725",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5726",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5727",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5728",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5729",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5730",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5731",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5732",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5733",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5734",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5735",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5736",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5737",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5738",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5739",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5740",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5741",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5742",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5743",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5744",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5745",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5746",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5747",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5748",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5749",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5750",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5751",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5752",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5753",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5754",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5755",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5756",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5757",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5758",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5759",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5760",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5761",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5762",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5763",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5764",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5765",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5766",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5767",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5768",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5769",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5770",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5771",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5772",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5773",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5774",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5775",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5776",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5777",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5778",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5779",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5780",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5781",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5782",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5783",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5784",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5785",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5786",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5787",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5788",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5789",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5790",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5791",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5792",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5793",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5794",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5795",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5796",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5797",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5798",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5799",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5800",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5801",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5802",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5803",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5804",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5805",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5806",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5807",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5611",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5612",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5613",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5614",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5615",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5616",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5617",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5618",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5619",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5620",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5621",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5622",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5808",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5809",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5810",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5811",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5812",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5573",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5574",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5650",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5651",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5652",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5653",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5658",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5659",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5660",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5661",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5050",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5570",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5871",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5872",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5873",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5874",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5875",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5876",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5877",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5878",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5879",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5880",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5881",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5882",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5883",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5884",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5885",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5886",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5887",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5888",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5889",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5890",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5891",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5892",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5893",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5894",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5895",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5896",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5897",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5902",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5903",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5904",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5905",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5814",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5815",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5816",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5817",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5819",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5820",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5823",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5824",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5825",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5826",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5827",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5828",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5829",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5830",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5831",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5832",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5833",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5910",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5911",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5912",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5913",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5914",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5915",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5916",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5917",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5918",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5919",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5920",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5921",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5922",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5923",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5924",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5925",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5926",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5927",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5928",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5929",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5930",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5931",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5932",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5933",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5934",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5935",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5936",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5937",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5834",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5835",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5836",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5837",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5838",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5839",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5840",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5841",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5842",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5843",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5844",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5845",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5846",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5847",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5848",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5849",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5850",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5851",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5852",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5853",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5938",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5939",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5940",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5941",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5942",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5943",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5944",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5945",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5946",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5855",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5857",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5948",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5949",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5950",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5951",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5952",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5953",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5954",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5955",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5956",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5957",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5958",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5959",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5960",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5961",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5962",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5963",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5964",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5965",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5966",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5967",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5968",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5969",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5970",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5971",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5972",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5973",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5974",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5975",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5976",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5977",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5978",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5979",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5980",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5981",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5982",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5983",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5984",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5985",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5986",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5987",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5988",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5989",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5990",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5991",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5992",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5993",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5994",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5995",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5996",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5997",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5998",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5999",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6000",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6001",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6002",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6003",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6004",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6005",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6006",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6007",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6008",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6009",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6010",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6011",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6012",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6013",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6014",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6015",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6016",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6017",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6018",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6019",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6020",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6021",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6022",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6023",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6024",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6025",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6026",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6027",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6028",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6029",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6030",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6031",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6032",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6033",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6034",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6035",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6036",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6037",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6038",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6039",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6040",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6041",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6042",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6043",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6044",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6045",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6046",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6047",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6048",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6049",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6050",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6051",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6052",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6053",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6054",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6055",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5859",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5860",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5861",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5862",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5863",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5864",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5865",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5866",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5867",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5868",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5869",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5870",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "6056",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6057",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6058",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6059",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6060",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6061",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5821",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5822",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5898",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5899",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5900",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5901",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5906",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5907",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5908",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5909",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5052",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5818",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6106",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6107",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6108",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6109",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6110",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6111",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6112",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6113",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6114",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6115",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6116",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6117",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6118",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6119",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6120",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6121",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6122",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6123",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6124",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6125",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6126",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6130",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6131",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6132",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6062",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6063",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6064",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6065",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6067",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6069",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6070",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6071",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6072",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6073",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6074",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6136",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6137",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6138",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6139",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6140",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6141",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6142",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6143",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6144",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6145",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6146",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6147",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6148",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6149",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6150",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6151",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6152",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6153",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6154",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6155",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6156",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6075",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6076",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6077",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6078",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6079",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6080",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6081",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6082",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6083",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6084",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6085",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6086",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6087",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6088",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6089",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6090",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6091",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6092",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6093",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6094",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6157",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6158",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6159",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6160",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6161",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6162",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6163",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6164",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6165",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6166",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6095",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6096",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6097",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6098",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6099",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6167",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6168",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6169",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6170",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6171",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6172",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6173",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6174",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6175",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6176",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6177",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6178",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6179",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6180",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6181",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6182",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6183",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6184",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6185",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6186",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6187",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6188",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6189",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6190",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6192",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6193",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6194",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6195",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6197",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6198",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6199",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6200",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6201",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6202",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6203",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6204",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6205",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6206",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6207",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6208",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6209",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6210",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6211",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6212",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6213",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6214",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6215",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6216",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6217",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6218",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6219",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6220",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6221",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6222",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6223",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6224",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6225",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6226",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6227",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6228",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6229",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6230",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6231",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6232",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6233",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6234",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6235",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6236",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6237",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6238",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6100",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6101",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6102",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6103",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6104",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6105",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6239",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6240",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6241",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6068",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6127",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6128",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6129",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6133",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6134",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6135",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5083",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6066",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6286",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6287",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6289",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6290",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6291",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6292",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6295",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6296",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6297",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6298",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6299",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6301",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6302",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6303",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6304",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6305",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6306",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6310",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6311",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6312",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6242",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6243",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6244",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6245",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6247",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6249",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6250",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6251",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6252",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6253",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6254",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6316",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6317",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6318",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6319",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6320",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6321",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6322",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6323",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6324",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6326",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6327",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6328",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6329",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6330",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6331",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6332",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6333",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6334",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6335",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6336",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6255",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6256",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6257",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6258",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6259",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6260",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6261",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6262",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6263",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6265",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6266",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6267",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6268",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6271",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6272",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6273",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6337",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6338",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6339",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6340",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6341",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6342",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6343",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6344",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6345",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6346",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6275",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6276",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6277",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6278",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6279",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6347",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6348",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6349",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6350",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6351",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6352",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6353",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6354",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6355",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6356",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6357",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6358",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6359",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6360",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6361",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6362",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6363",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6364",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6365",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6366",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6367",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6368",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6369",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6370",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6371",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6372",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6373",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6374",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6375",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6376",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6377",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6378",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6379",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6380",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6382",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6383",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6384",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6385",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6386",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6387",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6388",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6389",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6390",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6391",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6392",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6393",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6394",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6395",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6396",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6397",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6398",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6399",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6400",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6401",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6402",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6403",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6404",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6405",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6406",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6407",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6408",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6409",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6410",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6411",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6412",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6413",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6414",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6415",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6416",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6417",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6418",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6280",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6281",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6283",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6284",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6285",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6419",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6420",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6421",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6248",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6307",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6308",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6309",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6313",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6314",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6315",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5086",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6246",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1487",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1488",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1489",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1490",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1491",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1492",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1493",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1494",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1495",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1496",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1497",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1498",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1499",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1500",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1501",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1502",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1503",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1504",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1505",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1506",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1507",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1508",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1509",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1510",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1511",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1512",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1513",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1514",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1515",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1516",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1517",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1518",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1519",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1525",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1526",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1527",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1528",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1529",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1439",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1440",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1441",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1442",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1444",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1446",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1447",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1448",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1449",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1450",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1451",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1535",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1536",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1537",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1538",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1539",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1540",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1541",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1542",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1543",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1544",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1545",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1546",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1547",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1548",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1549",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1550",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1551",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1552",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1553",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1554",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1555",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1556",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1557",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1558",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1559",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1452",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1453",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1454",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1455",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1456",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1457",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1458",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1459",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1460",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1461",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1462",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1463",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1464",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1465",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1466",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1467",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1468",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1469",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1470",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1471",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1560",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1561",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1562",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1563",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1564",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1565",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1566",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1567",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1568",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1569",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1472",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1473",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1474",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1475",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1476",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1570",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1571",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1572",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1573",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1574",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1575",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1576",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1577",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1578",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1579",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1580",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1581",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1582",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1583",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1584",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1585",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1586",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1587",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1588",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1589",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1590",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1591",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1592",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1593",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1594",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1595",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1596",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1597",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1598",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1599",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1600",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1601",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1602",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1603",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1604",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1605",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1606",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1607",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1608",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1609",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1610",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1611",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1612",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1613",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1614",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1615",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1616",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1617",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1618",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1619",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1620",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1621",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1622",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1623",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1624",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1625",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1626",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1627",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1628",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1629",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1630",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1631",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1632",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1633",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1634",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1635",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1636",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1637",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1638",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1639",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1640",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1641",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1642",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1643",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1644",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1645",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1646",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1647",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1648",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1650",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1651",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1652",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1653",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1654",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1477",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1478",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1479",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1480",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1481",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1482",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1483",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1484",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1485",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1486",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1655",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1656",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1657",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1658",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1659",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1445",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1520",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1521",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1522",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1523",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1524",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1530",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1531",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1532",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1533",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1534",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "511",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1443",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1708",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1709",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1710",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1711",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1712",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1713",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1714",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1715",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1716",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1717",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1718",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1719",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1720",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1721",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1722",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1723",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1724",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1725",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1726",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1727",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1728",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1729",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1730",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1731",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1732",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1733",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1734",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1735",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1736",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1737",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1738",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1739",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1740",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1746",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1747",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1748",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1749",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1750",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1660",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1661",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1662",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1663",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1665",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1667",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1668",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1669",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1670",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1671",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1672",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1756",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1757",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1758",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1759",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1760",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1761",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1762",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1763",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1764",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1765",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1766",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1767",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1768",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1769",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1771",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1772",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1773",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1774",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1775",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1776",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1777",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1778",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1779",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1780",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1673",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1674",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1675",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1676",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1677",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1678",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1679",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1680",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1681",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1682",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1683",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1684",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1685",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1686",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1687",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1688",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1689",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1690",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1691",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1692",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1781",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1782",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1783",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1784",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1785",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1786",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1787",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1788",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1789",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1790",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1693",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1694",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1695",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1696",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1697",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1791",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1792",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1793",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1794",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1795",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1796",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1797",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1798",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1799",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1800",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1801",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1802",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1803",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1804",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1805",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1806",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1807",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1808",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1809",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1810",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1811",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1812",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1813",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1814",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1815",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1816",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1817",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1818",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1819",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1820",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1821",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1822",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1823",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1824",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1825",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1826",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1827",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1828",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1829",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1830",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1831",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1832",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1833",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1834",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1835",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1836",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1837",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1838",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1839",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1840",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1841",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1842",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1843",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1844",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1845",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1846",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1847",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1848",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1849",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1850",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1851",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1852",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1853",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1854",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1855",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1856",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1857",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1858",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1859",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1860",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1861",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1862",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1863",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1864",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1865",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1866",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1867",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1868",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1869",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1870",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1871",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1872",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1873",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1874",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1875",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1698",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1699",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1700",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1701",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1702",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1703",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1704",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1705",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1706",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1707",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1876",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1877",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1878",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1879",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1880",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1666",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1741",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1742",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1743",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1744",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1745",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1751",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1752",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1753",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1754",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1755",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "512",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1664",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1929",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1930",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1931",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1932",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1933",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1934",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1935",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1936",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1937",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1938",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1939",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1940",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1941",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1942",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1943",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1944",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1945",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1946",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1947",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1948",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1949",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1950",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1951",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1952",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1953",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1954",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1955",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1956",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1957",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1958",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1959",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1960",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1961",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1967",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1968",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1969",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1970",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1971",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1881",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1882",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1883",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1884",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1886",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1888",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1889",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1890",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1891",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1892",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1893",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1977",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1978",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1979",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1980",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1981",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1982",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1983",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1984",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1985",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1986",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1987",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1988",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1989",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1990",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1991",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1992",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1993",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1994",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1995",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1996",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1997",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1998",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1999",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2000",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2001",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1894",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1895",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1896",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1897",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1898",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1899",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1900",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1901",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1902",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1903",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1904",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1905",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1906",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1907",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1908",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1909",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1910",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1911",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1912",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1913",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2002",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2003",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2004",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2005",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2006",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2007",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2008",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2009",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2010",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2011",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1914",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1915",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1916",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1917",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1918",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2012",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2013",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2014",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2015",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2016",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2017",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2018",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2019",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2020",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2022",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2023",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2024",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2025",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2026",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2027",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2028",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2029",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2030",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2031",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2032",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2033",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2034",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2035",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2036",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2037",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2038",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2039",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2040",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2041",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2042",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2043",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2044",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2045",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2046",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2047",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2048",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2049",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2050",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2051",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2052",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2053",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2054",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2055",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2056",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2057",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2058",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2059",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2060",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2061",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2062",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2063",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2064",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2065",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2066",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2067",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2068",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2069",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2070",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2072",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2073",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2074",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2075",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2076",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2077",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2078",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2079",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2080",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2082",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2083",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2084",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2085",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2086",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2087",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2088",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2089",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2090",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2091",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2092",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2093",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2094",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2095",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2096",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1919",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1920",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1921",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1922",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1923",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1924",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1925",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1926",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1927",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2097",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2098",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2099",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2100",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2101",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1887",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1962",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1963",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1964",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1965",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1966",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1972",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "1973",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1974",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1975",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "1976",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "513",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "1885",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2150",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2151",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2152",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2153",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2154",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2155",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2156",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2157",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2158",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2159",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2160",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2161",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2162",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2163",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2164",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2165",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2166",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2167",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2168",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2169",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2170",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2171",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2172",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2173",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2174",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2175",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2176",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2177",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2178",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2179",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2180",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2181",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2182",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2188",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2189",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2190",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2191",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2192",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2102",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2103",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2104",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2105",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2107",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2109",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2110",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2111",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2112",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2113",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2114",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2198",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2199",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2200",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2201",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2202",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2203",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2204",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2205",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2206",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2207",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2208",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2209",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2210",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2211",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2212",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2213",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2214",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2215",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2216",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2217",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2218",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2219",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2220",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2221",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2222",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2115",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2116",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2117",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2118",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2119",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2120",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2121",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2122",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2123",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2124",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2125",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2126",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2127",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2128",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2129",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2130",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2131",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2132",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2133",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2134",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2223",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2224",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2225",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2226",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2227",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2228",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2229",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2230",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2231",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2232",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2135",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2136",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2137",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2138",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2139",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2233",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2234",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2235",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2236",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2237",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2238",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2239",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2240",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2241",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2242",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2243",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2244",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2245",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2246",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2247",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2248",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2249",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2250",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2251",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2252",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2253",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2254",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2255",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2256",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2257",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2258",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2259",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2260",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2261",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2262",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2263",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2264",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2265",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2266",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2267",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2268",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2269",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2270",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2271",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2272",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2273",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2274",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2275",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2276",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2277",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2278",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2279",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2280",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2281",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2283",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2284",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2285",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2286",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2287",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2288",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2289",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2290",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2291",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2292",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2293",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2294",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2295",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2296",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2297",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2298",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2299",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2300",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2301",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2302",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2303",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2304",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2305",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2306",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2307",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2308",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2309",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2310",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2311",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2312",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2313",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2314",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2315",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2316",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2317",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2140",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2141",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2142",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2143",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2144",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2145",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2146",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2147",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2148",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2149",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2318",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2319",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2320",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2321",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2322",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2108",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2183",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2184",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2185",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2186",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2187",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2193",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2194",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2195",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2196",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2197",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "514",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2106",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6470",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6471",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6472",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6473",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6474",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6475",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6476",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6477",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6478",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6479",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6480",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6481",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6482",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6483",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6484",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6485",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6486",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6487",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6488",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6489",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6490",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6491",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6492",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6493",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6494",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6495",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6496",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6497",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6498",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6499",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6500",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6501",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6502",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6508",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6509",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6510",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6511",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6512",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6422",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6423",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6424",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6425",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6427",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6429",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6430",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6431",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6432",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6433",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6434",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6518",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6519",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6520",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6521",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6522",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6523",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6524",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6525",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6526",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6527",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6528",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6529",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6530",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6531",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6532",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6533",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6534",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6535",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6536",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6537",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6538",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6539",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6540",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6541",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6542",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6435",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6436",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6437",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6438",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6439",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6440",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6441",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6442",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6443",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6444",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6445",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6446",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6447",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6448",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6449",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6450",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6451",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6452",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6453",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6454",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6543",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6544",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6545",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6546",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6547",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6548",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6549",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6550",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6551",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6552",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6455",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6456",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6457",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6458",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6459",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6553",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6554",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6555",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6556",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6557",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6558",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6559",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6560",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6561",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6562",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6563",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6564",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6565",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6566",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6568",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6569",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6570",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6571",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6572",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6573",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6574",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6575",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6576",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6577",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6578",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6579",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6580",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6581",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6582",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6583",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6584",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6585",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6586",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6587",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6588",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6589",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6590",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6591",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6592",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6593",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6594",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6595",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6596",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6597",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6598",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6599",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6600",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6601",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6602",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6603",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6604",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6605",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6606",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6607",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6608",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6609",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6610",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6611",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6612",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6613",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6614",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6615",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6616",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6617",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6618",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6619",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6620",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6621",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6622",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6623",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6624",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6625",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6626",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6627",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6628",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6629",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6630",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6631",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6632",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6633",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6634",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6635",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6636",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6637",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6460",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6461",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6462",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6463",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6464",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6465",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6466",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6467",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6468",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6469",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6638",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6639",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6640",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6641",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6642",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6428",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6503",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6504",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6505",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6506",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6507",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6513",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6514",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6515",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6516",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6517",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5154",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6426",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6691",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6692",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6693",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6694",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6695",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6696",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6697",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6698",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6699",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6700",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6701",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6702",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6703",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6704",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6705",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6706",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6707",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6708",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6709",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6710",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6711",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6712",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6713",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6714",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6715",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6716",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6717",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6718",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6719",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6720",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6721",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6722",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6723",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6729",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6730",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6731",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6732",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6733",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6643",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6644",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6645",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6646",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6648",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6650",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6651",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6652",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6653",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6654",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6655",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6739",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6740",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6741",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6742",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6743",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6744",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6745",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6746",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6747",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6748",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6749",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6750",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6751",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6752",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6753",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6754",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6755",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6756",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6757",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6758",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6759",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6760",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6761",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6762",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6763",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6656",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6657",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6658",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6659",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6660",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6661",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6662",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6663",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6664",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6665",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6666",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6667",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6668",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6669",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6670",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6671",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6672",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6673",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6674",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6675",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6764",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6765",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6766",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6767",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6768",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6769",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6770",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6771",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6772",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6773",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6676",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6677",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6678",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6679",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6680",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6774",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6775",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6776",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6777",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6778",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6779",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6780",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6781",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6782",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6783",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6784",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6785",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6786",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6787",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6788",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6789",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6790",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6791",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6792",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6793",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6794",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6795",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6796",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6797",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6798",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6799",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6800",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6801",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6802",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6803",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6804",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6805",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6806",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6807",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6808",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6809",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6810",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6811",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6812",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6814",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6815",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6816",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6817",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6818",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6819",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6820",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6821",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6822",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6823",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6824",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6825",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6826",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6827",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6828",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6829",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6830",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6831",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6832",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6833",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6834",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6835",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6836",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6837",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6838",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6839",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6840",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6841",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6842",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6843",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6844",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6845",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6846",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6847",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6848",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6849",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6850",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6851",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6852",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6853",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6855",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6857",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6681",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6682",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6683",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6684",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6685",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6686",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6687",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6688",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6689",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6690",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6859",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6860",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6861",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6862",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6863",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6649",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6724",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6725",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6726",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6727",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6728",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6734",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6735",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6736",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6737",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6738",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5254",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6647",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2371",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2372",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2373",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2374",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2375",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2376",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2377",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2378",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2379",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2380",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2381",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2382",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2383",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2384",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2386",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2387",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2388",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2389",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2390",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2391",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2392",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2393",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2394",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2395",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2396",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2397",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2398",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2399",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2400",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2401",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2402",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2403",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2409",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2410",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2411",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2412",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2413",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2323",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2324",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2325",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2326",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2328",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2330",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2331",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2332",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2333",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2334",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2335",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2419",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2420",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2421",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2422",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2424",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2425",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2426",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2427",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2428",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2429",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2430",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2431",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2432",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2433",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2434",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2435",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2436",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2437",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2438",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2439",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2440",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2441",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2442",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2443",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2336",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2337",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2338",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2339",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2340",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2341",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2342",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2343",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2344",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2345",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2346",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2347",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2348",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2349",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2350",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2351",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2352",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2353",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2354",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2444",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2445",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2446",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2447",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2448",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2449",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2450",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2451",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2452",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2453",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2356",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2357",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2358",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2359",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2360",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2454",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2455",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2456",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2457",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2458",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2459",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2460",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2461",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2462",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2463",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2464",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2465",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2466",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2467",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2468",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2469",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2470",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2471",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2472",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2473",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2474",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2475",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2476",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2477",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2478",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2479",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2480",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2481",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2482",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2483",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2484",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2485",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2486",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2487",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2488",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2489",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2490",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2491",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2492",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2493",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2494",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2495",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2496",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2497",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2498",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2499",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2500",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2501",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2502",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2503",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2504",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2505",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2506",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2507",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2508",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2509",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2510",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2511",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2512",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2513",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2514",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2515",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2516",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2517",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2518",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2519",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2520",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2521",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2522",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2523",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2524",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2525",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2526",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2527",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2528",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2529",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2530",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2531",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2532",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2533",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2534",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2535",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2536",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2537",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2538",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2361",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2362",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2363",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2364",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2365",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2366",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2367",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2368",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2369",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2370",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2539",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2540",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2541",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2542",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2543",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2329",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2404",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2405",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2406",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2407",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2408",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2414",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2415",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2416",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2417",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2418",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "535",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2327",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6908",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6909",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6910",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6911",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6912",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6913",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6914",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6915",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6916",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6917",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6918",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6919",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6920",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6921",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6922",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6923",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6924",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6925",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6926",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6927",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6932",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6933",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6934",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6864",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6865",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6866",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6867",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6869",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6871",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6872",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6873",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6874",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6875",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6876",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6938",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6939",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6940",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6941",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6942",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6943",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6944",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6945",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6946",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6948",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6949",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6950",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6951",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6952",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6953",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6954",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6955",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6956",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6957",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6958",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6877",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6878",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6879",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6880",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6881",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6882",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6883",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6884",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6885",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6886",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6887",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6888",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6889",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6890",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6891",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6892",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6893",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6894",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6895",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6896",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6959",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6960",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6961",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6962",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6963",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6964",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6965",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6966",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6967",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6968",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6897",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6898",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6899",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6900",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6901",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6969",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6970",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6971",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6972",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6973",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6974",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6975",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6976",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6977",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6978",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6979",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6980",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6981",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6982",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6983",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6984",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6985",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6986",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6987",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6988",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6989",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6990",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6991",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6992",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6993",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6994",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6995",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6996",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6997",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6998",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6999",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7000",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7001",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7002",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7003",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7004",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7005",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7006",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7007",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7008",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7009",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7010",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7011",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7012",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7013",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7014",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7015",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7016",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7017",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7018",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7019",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7020",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7021",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7022",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7023",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7024",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7025",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7026",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7027",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7028",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7029",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7030",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7031",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7032",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7033",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7034",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7035",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7036",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7037",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7038",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7039",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7040",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6902",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6903",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6904",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6905",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6906",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6907",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7041",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7042",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7043",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6870",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6929",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6930",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6931",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6935",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "6936",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "6937",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5383",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "6868",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7092",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7093",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7094",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7095",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7096",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7097",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7098",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7099",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7100",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7101",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7102",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7103",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7104",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7105",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7106",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7107",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7108",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7109",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7110",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7111",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7112",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7113",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7114",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7115",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7116",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7117",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7118",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7123",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7124",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7125",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7126",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7044",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7045",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7046",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7047",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7049",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7051",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7052",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7053",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7054",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7055",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7056",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7131",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7132",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7133",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7134",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7135",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7136",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7137",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7138",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7139",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7140",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7141",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7142",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7143",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7144",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7145",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7146",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7147",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7148",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7149",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7150",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7151",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7152",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7153",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7057",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7058",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7059",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7060",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7061",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7062",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7063",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7064",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7065",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7066",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7067",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7068",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7069",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7070",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7072",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7073",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7074",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7075",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7076",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7154",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7155",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7156",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7157",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7159",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7160",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7161",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7162",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7163",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7077",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7078",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7079",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7080",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7164",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7165",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7166",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7167",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7168",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7169",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7170",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7171",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7172",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7173",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7174",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7175",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7176",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7177",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7178",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7179",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7180",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7181",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7182",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7183",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7184",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7185",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7186",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7187",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7188",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7189",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7190",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7192",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7193",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7194",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7195",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7197",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7198",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7199",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7200",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7201",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7202",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7203",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7204",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7205",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7206",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7207",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7208",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7209",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7210",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7211",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7212",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7213",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7214",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7215",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7216",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7217",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7218",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7219",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7220",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7221",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7222",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7223",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7224",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7225",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7226",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7227",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7228",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7229",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7230",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7231",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7232",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7233",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7234",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7235",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7236",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7237",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7238",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7239",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7240",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7241",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7242",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7243",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7244",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7245",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7246",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7082",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7083",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7084",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7085",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7086",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7087",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7088",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7089",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7090",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7091",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7247",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7248",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7249",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7250",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7251",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7050",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7119",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7120",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7121",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7122",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7127",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7128",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7129",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7130",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5454",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7048",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7296",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7297",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7298",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7299",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7300",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7301",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7302",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7303",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7304",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7305",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7306",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7307",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7308",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7309",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7310",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7311",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7312",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7313",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7314",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7315",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7316",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7320",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7321",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7322",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "319",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7252",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "333",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7253",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "354",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7254",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "355",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7255",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "356",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7257",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "357",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7259",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "359",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7260",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "380",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7261",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "413",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7262",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "443",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7263",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "444",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7264",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7326",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7327",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7328",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7329",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7330",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7331",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7332",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7333",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7334",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7336",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7337",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7338",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7339",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7340",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7341",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7342",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7343",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7344",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7345",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7346",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7265",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7266",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7267",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7268",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7271",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7272",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7273",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7275",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7276",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7277",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7278",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7279",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7280",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7281",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7282",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7283",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7347",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7348",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7349",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7350",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7352",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7353",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7354",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7355",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7356",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7285",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7286",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7287",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7288",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7289",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7357",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7358",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7359",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7360",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7361",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7362",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7363",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7364",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7365",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7366",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7367",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7368",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7369",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7370",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7371",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7372",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7373",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7374",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7375",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7376",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7377",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7378",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7379",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7380",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7382",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7383",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7384",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7385",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7386",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7387",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7388",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7389",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7390",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7391",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7392",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7393",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7394",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7395",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7396",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7397",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7398",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7399",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7400",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7401",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7402",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7403",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7404",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7405",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7406",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7407",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7408",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7409",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7410",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7412",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7413",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7414",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7415",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7416",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7417",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7418",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7419",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7420",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7421",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7422",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7423",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7424",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7425",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7426",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7427",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7428",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "710",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7290",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7291",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7292",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "711",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7293",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7294",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7295",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7429",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7430",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7431",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7258",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7317",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7318",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7319",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7323",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7324",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5456",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7256",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7489",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7490",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7491",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7492",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7493",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7494",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7495",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7496",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7497",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7498",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7499",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7500",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7501",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7502",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7503",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7504",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7505",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7506",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7507",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7508",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7509",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7510",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7511",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7512",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7513",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7514",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7515",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7520",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7521",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7522",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7523",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7432",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7433",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7434",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7435",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7437",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7438",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7441",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7442",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7443",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7444",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7445",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7446",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7447",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7448",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7449",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7450",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7451",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7528",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7529",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7530",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7531",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7532",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7533",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7534",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7535",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7536",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7537",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7538",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7539",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7540",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7541",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7542",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7543",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7544",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7545",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7546",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7547",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7548",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7549",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7550",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7551",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7552",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7553",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7554",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7555",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7452",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7453",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7454",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7455",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7456",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7457",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7458",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7459",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7460",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7461",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7462",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7463",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7464",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7465",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7466",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7467",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7468",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7469",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7470",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7471",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7556",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7557",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7558",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7559",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7560",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7561",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7562",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7563",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7564",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7565",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7472",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7473",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7474",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7475",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7476",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7566",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7567",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7568",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7569",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7570",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7571",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7572",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7573",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7574",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7575",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7576",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7577",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7578",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7579",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7580",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7581",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7582",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7583",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7584",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7585",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7586",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7587",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7588",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7589",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7590",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7591",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7592",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7593",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7594",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7595",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7596",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7597",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7598",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7599",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7600",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7601",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7602",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7603",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7604",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7605",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7606",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7607",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7608",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7609",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7610",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7611",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7612",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7613",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7614",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7615",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7616",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7617",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7618",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7619",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7620",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7621",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7622",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7623",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7624",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7625",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7626",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7627",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7628",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7629",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7630",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7631",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7632",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7633",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7634",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7635",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7636",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7637",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7638",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7639",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7640",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7641",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7642",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7643",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7644",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7645",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7646",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7647",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7648",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7650",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7651",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7652",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7653",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7654",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7655",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7656",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7657",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7658",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7659",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7660",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7661",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7662",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7663",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7664",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7665",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7666",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7667",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7668",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7669",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7670",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7671",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7672",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7673",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7477",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7478",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7479",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7480",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7481",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7482",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7483",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7484",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7485",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7486",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7487",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7488",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7674",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7675",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7676",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7677",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7678",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7679",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7439",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7440",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7516",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7517",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7518",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7519",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7524",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7525",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7526",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7527",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "5652",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7436",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7743",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7744",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7745",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7746",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7747",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7748",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7749",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7750",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7751",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7752",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7753",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7754",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7755",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7756",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7757",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7758",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7759",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7760",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7761",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7762",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7763",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7764",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7765",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7766",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7767",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7768",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7769",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7770",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7771",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7772",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7773",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7774",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7775",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7776",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7777",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7778",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7779",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7780",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7781",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7782",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7783",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7784",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7791",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7792",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7793",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7794",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7795",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7796",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7680",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7681",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7682",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7683",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7684",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7685",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7686",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7687",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7690",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7691",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7694",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7695",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7696",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7697",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7698",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7699",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7700",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7701",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7702",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7703",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7704",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7705",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7803",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7804",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7805",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7806",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7807",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7808",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7809",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7810",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7811",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7812",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7813",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7814",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7815",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7816",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7817",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7818",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7819",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7820",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7821",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7822",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7823",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7824",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7825",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7826",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7827",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7828",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7829",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7830",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7831",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7832",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7833",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7706",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7707",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7708",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7709",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7710",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7711",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7712",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7713",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7714",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7715",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7716",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7717",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7718",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7719",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7720",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7721",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7722",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7723",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7724",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7725",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7834",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7835",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7836",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7837",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7838",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7839",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7840",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7841",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7842",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7843",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7726",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7727",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7728",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7729",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7730",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7844",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7845",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7846",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7847",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7848",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7849",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7850",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7851",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7852",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7853",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7855",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7857",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7859",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7860",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7861",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7862",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7863",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7864",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "7865",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7866",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7867",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7868",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7869",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7870",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7871",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7872",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7873",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7874",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7875",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7876",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7877",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7878",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7879",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7880",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7881",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7882",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7883",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7884",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7885",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7886",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7887",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7888",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7889",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7890",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7891",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7892",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7893",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7894",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7895",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7896",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7897",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7898",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7899",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7900",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7901",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7902",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7903",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7904",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7905",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7906",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7907",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7908",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7909",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7910",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7911",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7912",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7913",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7914",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7915",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7916",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7917",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7918",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7919",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7920",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7921",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "7922",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "7923",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7924",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7925",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "7926",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7927",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7929",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7930",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7931",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7932",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7933",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7934",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7935",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7936",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7937",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7938",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7939",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7940",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7941",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7942",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7943",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7944",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7945",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7946",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7947",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7948",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7949",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7950",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7951",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7952",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7731",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7732",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7733",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7734",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7735",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7736",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7737",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7738",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7739",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7740",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7741",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7742",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7953",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7954",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7955",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7956",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7957",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7958",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7692",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7693",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7785",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7786",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7787",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7788",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7789",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7790",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7797",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7798",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7799",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7800",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7801",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7802",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6005",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7688",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7689",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8022",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8023",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8024",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8025",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8026",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8027",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8028",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8029",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8030",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8031",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8032",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8033",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8034",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8035",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8036",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8037",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8038",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8039",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8040",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8041",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8042",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8043",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8044",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8045",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8046",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8047",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8048",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8049",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8050",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8051",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8052",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8053",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8054",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8055",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8056",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8057",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8058",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8059",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8060",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8061",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8062",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8063",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8070",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8071",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8072",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8073",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8074",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8075",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7959",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7960",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7961",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7962",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7963",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7964",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7965",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7966",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7969",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7970",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7973",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7974",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7975",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7976",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7977",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7978",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7979",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7980",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7981",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7982",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7983",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7984",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8082",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8083",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8084",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8085",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8086",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8087",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8088",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8089",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8090",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8091",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8092",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8093",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8094",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8095",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8096",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8097",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8098",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8099",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8100",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8101",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8102",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8103",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8104",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8105",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8106",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8107",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8108",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8109",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8110",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8111",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8112",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7985",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7986",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7987",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7988",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7989",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7990",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7991",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7992",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7993",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7994",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7995",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "7996",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7997",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7998",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "7999",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8000",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8001",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8002",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8003",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8004",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8113",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8114",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8115",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8116",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8117",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8118",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8119",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8120",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8121",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8122",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8005",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8006",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8007",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8008",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8009",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8123",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8124",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8125",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8126",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8127",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8128",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8129",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8130",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8131",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8132",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8133",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8134",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8135",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8136",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8137",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8138",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8139",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8140",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8141",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8142",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8143",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8144",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8145",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8146",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8147",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8148",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8149",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8150",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8151",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8152",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8153",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8154",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8155",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8156",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8157",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8159",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8160",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8161",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8162",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8163",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8164",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8165",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8166",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8167",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8168",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8169",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8170",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8171",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8172",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8173",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8174",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8175",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8176",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8177",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8178",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8179",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8180",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8181",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8182",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8183",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8184",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8185",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8186",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8187",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8188",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8189",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8190",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8191",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8192",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8193",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8194",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8195",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8196",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8197",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8198",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8199",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8201",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8202",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8203",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8204",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8205",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8206",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8207",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8208",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8209",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8210",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8211",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8212",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8213",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8214",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8215",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8216",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8217",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8218",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8219",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8220",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8221",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8222",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8223",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8224",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8225",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8226",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8227",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8228",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8229",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8230",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8231",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8010",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8011",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8012",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8013",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8014",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8015",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8016",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8017",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8018",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8019",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8020",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8232",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8233",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8234",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8235",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8236",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8237",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7971",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7972",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8064",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8065",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8066",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8067",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8068",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8069",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8076",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8077",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8078",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8079",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8080",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8081",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6061",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "7967",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "7968",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8302",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8303",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8304",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8305",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8306",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8307",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8308",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8309",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8310",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8311",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8312",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8313",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8314",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8315",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8316",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8317",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8318",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8319",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8320",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8321",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8322",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8323",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8324",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8325",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8326",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8327",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8328",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8329",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8330",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8331",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8332",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8333",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8334",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8336",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8337",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8338",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8339",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8340",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8341",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8342",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8343",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8350",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8351",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8352",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8353",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8354",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8238",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8239",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8240",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8241",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8242",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8243",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8244",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8245",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8248",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8249",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8253",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8254",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8255",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8256",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8257",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8258",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8259",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8260",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8261",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8262",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8263",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8361",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8362",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8363",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8364",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8365",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8366",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8368",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8369",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8370",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8371",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8372",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8373",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8374",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8375",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8376",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8377",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8378",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8379",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8380",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8382",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8383",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8384",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8385",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8386",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8387",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8388",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8389",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8390",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8391",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8265",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8266",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8267",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8268",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8269",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8271",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8272",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8273",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8275",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8276",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8277",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8278",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8279",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8280",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8281",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8282",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8283",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8392",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8393",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8394",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8395",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8396",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8397",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8398",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8399",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8400",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8401",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8285",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8286",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8287",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8288",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8289",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8402",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8403",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8404",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8405",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8406",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8407",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8408",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8409",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8410",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8412",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8413",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8414",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8415",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8416",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8417",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8418",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8419",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8420",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8421",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8422",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8424",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8425",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8426",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8427",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8428",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8429",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8430",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8431",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8432",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8433",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8434",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8435",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8436",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8437",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8438",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8439",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8440",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8441",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8442",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8443",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8444",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8445",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8446",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8447",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8448",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8449",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8450",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8451",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8452",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8453",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8454",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8455",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8456",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8457",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8458",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8459",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8460",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8461",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8462",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8463",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8464",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8465",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8466",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8467",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8468",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8469",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8470",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8471",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8472",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8473",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8474",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8475",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8476",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8477",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8478",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8479",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8480",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8481",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8482",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8483",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8484",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8485",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8486",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8487",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8488",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8489",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8490",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8491",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8492",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8493",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8494",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8495",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8496",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8497",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8498",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8499",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8500",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8501",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8502",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8503",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8504",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8505",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8506",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8507",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8508",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8509",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8510",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8290",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8291",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8292",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8294",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8295",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8296",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8297",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8298",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8299",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8300",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8301",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8511",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8512",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8513",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8514",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8515",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8516",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8250",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8251",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8344",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8345",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8346",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8347",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8348",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8349",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8252",
          "not_recommended": false
        },
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8356",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8357",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8358",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8359",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8360",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6063",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8246",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8247",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8580",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8581",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8582",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8583",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8584",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8585",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8586",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8587",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8588",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8589",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8590",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8591",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8592",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8593",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8594",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8595",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8596",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8597",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8598",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8599",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8600",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8601",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8602",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8603",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8604",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8605",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8606",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8607",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8608",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8609",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8610",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8611",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8612",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8613",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8614",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8615",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8616",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8617",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8618",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8619",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8620",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8621",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8628",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8629",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8630",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8631",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8632",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8633",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8517",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8518",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8519",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8520",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8521",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8522",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8523",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8524",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8527",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8528",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8531",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8532",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8533",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8534",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8535",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8536",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8537",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8538",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8539",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8540",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8541",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8542",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8640",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8641",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8642",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8643",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8644",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8645",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8646",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8647",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8648",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8649",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8650",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8651",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8652",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8653",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8654",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8655",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8656",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8657",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8658",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8659",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8660",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8661",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8662",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8663",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8664",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8665",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8666",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8667",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8668",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8669",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8670",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8543",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8544",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8545",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8546",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8547",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8548",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8549",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8550",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8551",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8552",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8553",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8554",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8555",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8556",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8557",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8558",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8559",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8560",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8561",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8562",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8671",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8672",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8673",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8674",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8675",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8676",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8677",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8678",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8679",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8680",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8563",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8564",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8565",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8566",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8681",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8682",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8683",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8684",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8685",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8686",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8687",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8688",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8689",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8690",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8691",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8692",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8693",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8694",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8695",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8696",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8697",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8698",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8699",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8700",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8701",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8702",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8703",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8704",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8705",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8706",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8707",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8708",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8709",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8710",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8711",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8712",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8713",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8714",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8715",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8716",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8717",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8718",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8719",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8720",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8721",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8722",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8723",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8724",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8725",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8726",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8727",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8728",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8729",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8730",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8731",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8732",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8733",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8734",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8735",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8736",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8737",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8738",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8739",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8740",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8741",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8742",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8743",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8744",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8745",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8746",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8747",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8748",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8749",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8750",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8751",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8752",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8753",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8754",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8755",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8756",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8757",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8758",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8759",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8760",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8761",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8762",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8763",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8764",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8765",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8766",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8767",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8768",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8769",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8770",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8771",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8772",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8773",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8774",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8775",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8776",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8777",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8778",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8779",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8780",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8781",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8782",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8783",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8784",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8785",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8786",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8787",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8788",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8789",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8568",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8569",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8570",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8571",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8572",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8573",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8574",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8575",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8576",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8577",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8578",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8579",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8790",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8791",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8792",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8793",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8794",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8795",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8529",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8530",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8622",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8623",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8624",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8625",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8626",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8627",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8634",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8635",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8636",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8637",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8638",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8639",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6070",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8525",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8526",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8859",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8860",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8861",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8862",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8863",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8864",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8865",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8866",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8867",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8868",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8869",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8870",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8871",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8872",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8873",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8874",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8875",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8876",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8877",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8878",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8879",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8880",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8881",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8882",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8883",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8884",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8885",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8886",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8887",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8888",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8889",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8890",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8891",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8892",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8893",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8894",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8895",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8896",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8897",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8898",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8899",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8900",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8907",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8908",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8909",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8910",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8911",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8912",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8796",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8797",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8798",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8799",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8800",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8801",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8802",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8803",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8806",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8807",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8810",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8811",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8812",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8814",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8815",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8816",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8817",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8818",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8819",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8820",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8821",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8919",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8920",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8921",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8922",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8923",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8924",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8925",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8926",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8927",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8928",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8929",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8930",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8931",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8932",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8933",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8934",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8935",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8936",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8937",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8938",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8939",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8940",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8941",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8942",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8943",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8944",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8945",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8946",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8947",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8948",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8949",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8822",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8823",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8824",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8825",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8826",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8827",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8828",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8829",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8830",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8831",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8832",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8833",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8834",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8835",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8836",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8837",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8838",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8839",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8840",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8841",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8950",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8951",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8952",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8953",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8954",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8955",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8956",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8957",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8958",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8959",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8842",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8843",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8844",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8845",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8846",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8960",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8961",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8962",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8963",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8964",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8965",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8966",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8967",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8968",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8969",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8970",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8971",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8972",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8973",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8974",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8975",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8976",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8977",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8978",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8979",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8980",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "8981",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8982",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8983",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8984",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8985",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8986",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8987",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8988",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8989",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8990",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8991",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8992",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "8993",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8994",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8995",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "8996",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "8997",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8998",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8999",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9000",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9001",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9002",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9003",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9004",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9005",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9006",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9007",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9008",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9009",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9010",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9011",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9012",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9013",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9014",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9015",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9016",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9017",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9018",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9019",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9020",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9021",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9022",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9023",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9024",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9025",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9026",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9027",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9028",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9029",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9030",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9031",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9032",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9033",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9034",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9035",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9036",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9037",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9038",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9039",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9040",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9041",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9042",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9043",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9044",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9045",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9046",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9047",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9048",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9049",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9050",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9051",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9052",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9053",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9054",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9055",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9056",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9057",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9058",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9059",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9060",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9061",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9062",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9063",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9064",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9065",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9066",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9067",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9068",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8847",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8848",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8849",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8850",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8851",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8852",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8853",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8855",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8857",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9069",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9070",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9071",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9072",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9073",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9074",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8808",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8809",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8901",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8902",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8903",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8904",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8905",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8906",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8913",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8914",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8915",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8916",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "8917",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "8918",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6082",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "8804",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "8805",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9138",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9139",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9140",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9141",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9142",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9143",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9144",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9145",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9146",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9147",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9148",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9149",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9150",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9151",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9152",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9153",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9154",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9155",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9156",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9157",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9158",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9159",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9160",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9161",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9162",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9163",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9164",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9165",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9166",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9167",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9168",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9169",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9170",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9171",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9172",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9173",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9174",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9175",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9176",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9177",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9178",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9179",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9186",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9187",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9188",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9189",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9190",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9191",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9075",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9076",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9077",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9078",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9079",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9080",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9081",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9082",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9085",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9086",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9089",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9090",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9091",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9092",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9093",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9094",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9095",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9096",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9097",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9098",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9099",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9100",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9198",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9199",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9200",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9201",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9202",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9203",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9204",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9205",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9206",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9207",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9208",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9209",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9210",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9211",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9212",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9213",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9214",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9215",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9216",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9217",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9218",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9219",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9220",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9221",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9222",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9223",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9224",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9225",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9226",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9227",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9228",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9101",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9102",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9103",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9104",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9105",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9106",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9107",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9108",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9109",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9110",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9111",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9112",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9113",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9114",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9115",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9116",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9117",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9118",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9119",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9120",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9229",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9230",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9231",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9232",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9233",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9234",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9235",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9236",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9237",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9238",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9121",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9122",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9123",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9124",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9125",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9239",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9240",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9241",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9242",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9243",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9244",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9245",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9246",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9247",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9248",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9249",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9250",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9251",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9252",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9253",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9254",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9255",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9256",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9257",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9258",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9259",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9260",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9261",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9262",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9263",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9264",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9265",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9266",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9267",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9268",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9269",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9271",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9272",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9273",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9274",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9275",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9276",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9277",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9278",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9279",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9280",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9281",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9282",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9283",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9284",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9285",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9286",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9287",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9289",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9290",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9291",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9292",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9294",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9295",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9296",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9297",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9298",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9299",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9300",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9301",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9302",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9303",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9304",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9305",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9306",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9307",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9308",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9309",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9310",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9311",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9312",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9313",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9314",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9315",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9316",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9317",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9318",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9319",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9320",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9321",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9322",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9323",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9324",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9325",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9326",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9327",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9328",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9329",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9330",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9331",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9332",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9333",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9334",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9336",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9337",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9338",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9339",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9340",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9341",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9342",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9343",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9344",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9345",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9346",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9347",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9126",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9127",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9128",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9129",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9130",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9131",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9132",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9133",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9134",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9135",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9136",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9137",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9348",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9349",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9350",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9351",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9352",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9353",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9087",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9088",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9180",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9181",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9182",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9183",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9184",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9185",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9192",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9193",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9194",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9195",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9196",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9197",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6151",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9083",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9084",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9417",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9418",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9419",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9420",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9421",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9422",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9423",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9424",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9425",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9426",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9427",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9428",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9429",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9430",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9431",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9432",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9433",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9434",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9435",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9436",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9437",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9438",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9439",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9440",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9441",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9442",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9443",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9444",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9445",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9446",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9447",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9448",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9449",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9450",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9451",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9452",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9453",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9454",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9455",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9456",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9457",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9458",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9465",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9466",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9467",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9468",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9469",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9470",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9354",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9356",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9357",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9358",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9359",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9360",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9361",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9364",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9365",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9368",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9369",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9370",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9371",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9372",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9373",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9374",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9375",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9376",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9377",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9378",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9379",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9477",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9478",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9479",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9480",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9481",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9482",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9483",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9484",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9485",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9486",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9487",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9488",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9489",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9490",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9491",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9492",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9493",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9494",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9495",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9496",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9497",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9498",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9499",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9500",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9501",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9502",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9503",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9504",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9505",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9506",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9507",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9380",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9381",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9382",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9383",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9384",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9385",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9386",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9387",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9388",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9389",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9390",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9391",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9392",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9393",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9394",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9395",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9396",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9397",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9398",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9399",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9508",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9509",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9510",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9511",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9512",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9513",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9514",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9515",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9516",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9517",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9400",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9401",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9402",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9403",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9404",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9518",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9519",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9520",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9521",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9522",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9523",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9524",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9525",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9526",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9527",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9528",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9529",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9530",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9531",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9532",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9533",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9534",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9535",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9536",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9537",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9538",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9539",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9540",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9541",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9542",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9543",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9544",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9545",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9546",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9547",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9548",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9549",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9550",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9551",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9552",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9553",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9554",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9555",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9556",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9557",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9558",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9559",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9560",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9561",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9562",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9563",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9564",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9565",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9566",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9568",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9569",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9570",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9571",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9572",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9573",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9574",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9575",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9576",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9577",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9578",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9579",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9580",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9582",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9583",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9584",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9585",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9586",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9587",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9588",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9589",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9590",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9591",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9592",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9593",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9594",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9595",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9596",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9597",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9598",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9599",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9600",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9601",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9602",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9603",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9604",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9605",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9606",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9607",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9608",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9609",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9610",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9611",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9612",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9613",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9614",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9615",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9616",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9617",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9618",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9619",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9620",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9621",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9622",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9623",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9624",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9625",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9626",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9405",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9406",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9407",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9408",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9409",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9410",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9411",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9412",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9413",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9414",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9415",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9416",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9627",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9628",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9629",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9630",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9631",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9632",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9366",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9459",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9460",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9461",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9462",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9463",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9464",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9471",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9472",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9473",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9474",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9475",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9476",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6201",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9362",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9363",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9697",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9698",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9699",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9700",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9701",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9702",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9703",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9704",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9705",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9706",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9707",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9708",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9709",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9710",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9711",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9712",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9713",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9714",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9715",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9716",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9717",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9718",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9719",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9720",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9721",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9722",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9723",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9724",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9725",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9726",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9727",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9728",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9729",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9730",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9731",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9732",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9733",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9734",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9735",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9736",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9737",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9738",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9745",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9746",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9747",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9748",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9749",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9750",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9633",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9634",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9635",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9636",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9637",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9638",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9639",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9640",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9643",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9644",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9648",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9650",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9651",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9652",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9653",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9654",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9655",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9656",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9657",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9658",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9659",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9756",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9757",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9758",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9759",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9760",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9761",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9762",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9763",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9764",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9765",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9766",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9767",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9768",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9769",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9770",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9771",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9772",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9773",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9774",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9775",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9776",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9777",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9778",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9779",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9780",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9781",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9782",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9783",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9784",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9785",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9786",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9660",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9661",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9662",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9663",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9664",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9665",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9666",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9667",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9668",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9669",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9670",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9671",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9672",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9673",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9674",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9675",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9676",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9677",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9678",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9679",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9787",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9788",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9789",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9790",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9791",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9792",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9793",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9794",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9795",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9796",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9680",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9681",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9682",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9683",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9684",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9797",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9798",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9799",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9800",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9801",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9802",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9803",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9804",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9805",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9806",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9807",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9808",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9809",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9810",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9811",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9812",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9813",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9814",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9815",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9816",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9817",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "9818",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9819",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9820",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9821",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9822",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9823",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9824",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9825",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9826",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9827",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9828",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9829",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9830",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9831",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9832",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9833",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9834",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9835",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9836",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9837",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9838",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9839",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9840",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9841",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9842",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9843",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9844",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9845",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9846",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9847",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9848",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9849",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9850",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9851",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9852",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9853",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9854",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9855",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9856",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9857",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9858",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9859",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9860",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9861",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9862",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9863",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9864",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9865",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9866",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9867",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9868",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9869",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9870",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9871",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9872",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9873",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9874",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "9875",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "9876",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9877",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9878",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "9879",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9880",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9881",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9882",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9883",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9884",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9885",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9886",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9887",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9888",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9889",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9890",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9891",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9892",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9893",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9894",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9895",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9896",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9897",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9898",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9899",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9900",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9901",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9902",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9903",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9904",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9905",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9685",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9686",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9687",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9688",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9689",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9690",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9691",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9692",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9693",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9694",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9695",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9696",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9906",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9907",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9908",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9909",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9910",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9911",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9645",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9646",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9739",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9740",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9741",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9742",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9743",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9744",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9647",
          "not_recommended": false
        },
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9751",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9752",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9753",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9754",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9755",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6351",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9641",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9642",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9976",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9977",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9978",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9979",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9980",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9981",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9982",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9983",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9984",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9985",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9986",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9987",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9988",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9989",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9990",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9991",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9992",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9993",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9994",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9995",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9996",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9997",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9998",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9999",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10000",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10001",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10002",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10003",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10004",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10005",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10006",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10007",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10008",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10009",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10010",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10011",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10012",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10013",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10014",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10015",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10016",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10017",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10024",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10025",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10026",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10027",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10028",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10029",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9912",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9913",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9914",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9915",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9916",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9917",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9918",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9919",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9922",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9923",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9927",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9929",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9930",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9931",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9932",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9933",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9934",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9935",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9936",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9937",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9938",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10035",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10036",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10037",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10038",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10039",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10040",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10041",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10042",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10043",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10044",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10045",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10046",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10047",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10048",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10049",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10050",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10051",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10052",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10053",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10054",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10055",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10056",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10057",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10058",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10059",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10060",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10061",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10062",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10063",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10064",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10065",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9939",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9940",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9941",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9942",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9943",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9944",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9945",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9946",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9947",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9948",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9949",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9950",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9951",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9952",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9953",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9954",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9955",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9956",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9957",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9958",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10066",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10067",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10068",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10069",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10070",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10071",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10072",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10073",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10074",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10075",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9959",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9960",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9961",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9962",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9963",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10076",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10077",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10078",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10079",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10080",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10081",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10082",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10083",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10084",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10085",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10086",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10087",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10088",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10089",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10090",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10091",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10092",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10093",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10094",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10095",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10096",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10097",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10098",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10099",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10100",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10101",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10102",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10103",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10104",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10105",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10106",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10107",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10108",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10109",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10110",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10111",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10112",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10113",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10114",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10115",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10116",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10117",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10118",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10119",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10120",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10121",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10122",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10123",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10124",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10125",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10126",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10127",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10128",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10129",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10130",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10131",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10132",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10133",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10134",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10135",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10136",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10137",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10138",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10139",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10140",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10141",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10142",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10143",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10144",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10145",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10146",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10147",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10148",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10149",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10150",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10151",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10152",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10153",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "B",
            "toughness": "D"
          },
          "sort_number": "10154",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "10155",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10156",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10157",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "B",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10158",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10159",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10160",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10161",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10162",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10163",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10164",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10165",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10166",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10167",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10168",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10169",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10170",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10171",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10172",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10173",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10174",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10175",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10176",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10177",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10178",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10179",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10180",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10181",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10182",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10183",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10184",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9964",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9965",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9966",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9967",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9968",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9969",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9970",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9971",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9972",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9973",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9974",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "9975",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10185",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10186",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10187",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10188",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10189",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10190",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9924",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9925",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10018",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10019",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10020",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10021",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10022",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10023",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10030",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10031",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10032",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10033",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10034",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "9926",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "6951",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "9920",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "9921",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10261",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10262",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10263",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10265",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10266",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10267",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10268",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10269",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10271",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10272",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10273",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10274",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10275",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10276",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10277",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10278",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10279",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10280",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10281",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10283",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10285",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10286",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10287",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10288",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10289",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10290",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10295",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10296",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10297",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10298",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10299",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10191",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10192",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10193",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10194",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10195",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10197",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10198",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10201",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10202",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10203",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10207",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10208",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10209",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10210",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10211",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10212",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10213",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10214",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10215",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10216",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10217",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10218",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10219",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10220",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10221",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10222",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10223",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10307",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10308",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10309",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10310",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10311",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10312",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10313",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10314",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10315",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10316",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10317",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10318",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10319",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10320",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10321",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10322",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10323",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10324",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10325",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10326",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10327",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10328",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10329",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10330",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10224",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10225",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10226",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10227",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10228",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10229",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10230",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10231",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10232",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10233",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10234",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10235",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10236",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10237",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10238",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10239",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10240",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10241",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10242",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10243",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10331",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10332",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10333",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10334",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10335",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10336",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10337",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10338",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10339",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10340",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10244",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10245",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10246",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10247",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10248",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10341",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10342",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10343",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10344",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10345",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10346",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10347",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10348",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10349",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10350",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10351",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10352",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10353",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10354",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10355",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10356",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10357",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10358",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10359",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10360",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10361",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10362",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10363",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10364",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10365",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10366",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10367",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10368",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10369",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10370",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10371",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10372",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10373",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10374",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10375",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10376",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10377",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10378",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10379",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10380",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10381",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10382",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10383",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10384",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10385",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10386",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10387",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10388",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10389",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10390",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10391",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10392",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10393",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10394",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10395",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10396",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10397",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10398",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10399",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10400",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10401",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10402",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10403",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10404",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10405",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10406",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10407",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10408",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10409",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10410",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10412",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10413",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10414",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10415",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10416",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10417",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10418",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10419",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10420",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10421",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10422",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10424",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10425",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10426",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10427",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10428",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10429",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10430",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10431",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10432",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10433",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10434",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10435",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10249",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10250",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10251",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10252",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10253",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10254",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10255",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10256",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10257",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10258",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10259",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10260",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10436",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10437",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10438",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10439",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10440",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10441",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10204",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10205",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10206",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10291",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10292",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10301",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10302",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10303",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10304",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10305",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10306",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7005",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10199",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10512",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10513",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10514",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10515",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10516",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10517",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10518",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10519",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10520",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10521",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10522",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10523",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10524",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10525",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10526",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10527",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10528",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10529",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10530",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10531",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10532",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10533",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10534",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10535",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10536",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10537",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10538",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10539",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10540",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10541",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10546",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10547",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10548",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10549",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10550",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10551",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10442",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10443",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10444",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10445",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10446",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10447",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10448",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10449",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10452",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10453",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10454",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10458",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10459",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10460",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10461",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10462",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10463",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10464",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10465",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10466",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10467",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10468",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10469",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10470",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10471",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10472",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10473",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10474",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10558",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10559",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10560",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10561",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10562",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10563",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10564",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10565",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10566",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10567",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10568",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10569",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10570",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10571",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10572",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10573",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10574",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10575",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10576",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10577",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10578",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10579",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10580",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10475",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10476",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10477",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10478",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10479",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10480",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10481",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10482",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10483",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10484",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10485",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10486",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10487",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10488",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10489",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10490",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10491",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10492",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10493",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10494",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10582",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10583",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10584",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10585",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10586",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10587",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10588",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10589",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10590",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10591",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10495",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10496",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10497",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10498",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10499",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10592",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10593",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10594",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10595",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10596",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10597",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10598",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10599",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10600",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10601",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10602",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10603",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10604",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10605",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10606",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10607",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10608",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10609",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10610",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10611",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10612",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10613",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10614",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10615",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10616",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10617",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10618",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10619",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10620",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10621",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10622",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10623",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10624",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10625",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10626",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10627",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10628",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10629",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10630",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10631",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10632",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10633",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10634",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10635",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10636",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10637",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10638",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10639",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10640",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10641",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10642",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10643",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10644",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10645",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10646",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10647",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10648",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10649",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10650",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10651",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10652",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10653",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10654",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10655",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10656",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10657",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10658",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10659",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10660",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10661",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10662",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10663",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10664",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10665",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10666",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10667",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10668",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10669",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10670",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10671",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10672",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10673",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10674",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10675",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10676",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10677",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10678",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10679",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10680",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10681",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10682",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10683",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10684",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10685",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10686",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10500",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10501",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10502",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10503",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10504",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10505",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10506",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10507",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10508",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10509",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10510",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10511",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10687",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10688",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10689",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10690",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10691",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10692",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10455",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10456",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10457",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10542",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10543",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10544",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10545",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10552",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10553",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10554",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10555",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10556",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10557",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7021",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10450",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10451",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10763",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10764",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10765",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10766",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10767",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10768",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10769",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10771",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10772",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10773",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10774",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10775",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10776",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10777",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10778",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10779",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10780",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10781",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10782",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10783",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10784",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10785",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10786",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10787",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10788",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10789",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10790",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10791",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10792",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10797",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10798",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10799",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10800",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10801",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10802",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10693",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10694",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10695",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10696",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10697",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10698",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10699",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10700",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10703",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10704",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10705",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10709",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10710",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10711",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10712",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10713",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10714",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10715",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10716",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10717",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10718",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10719",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10720",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10721",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10722",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10723",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10724",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10725",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10809",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10810",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10811",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10812",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10813",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10814",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10815",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10816",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10817",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10818",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10819",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10820",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10821",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10822",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10823",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10824",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10825",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10826",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10827",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10828",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10829",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10830",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10831",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10832",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10726",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10727",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10728",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10729",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10730",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10731",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10732",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10733",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10734",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10735",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10736",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10737",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10738",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10739",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10740",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10741",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10742",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10743",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10744",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10745",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10833",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10834",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10835",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10836",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10837",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10838",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10839",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10840",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10841",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10842",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10746",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10747",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10748",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10749",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10750",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10843",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10844",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10845",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10846",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10847",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10848",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10849",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10850",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10851",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10852",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10853",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10854",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10855",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10856",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10857",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10858",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10859",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10860",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10861",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10862",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10863",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10864",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10865",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10866",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10867",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10868",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10869",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10870",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10871",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10872",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10873",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10874",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10875",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10876",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10877",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10878",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10879",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10880",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10881",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10882",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10883",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10884",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10885",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10886",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10887",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10888",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10889",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10890",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10891",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10892",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10893",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10894",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10895",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10896",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10897",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10898",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10899",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10900",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10901",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10902",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10903",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10904",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10905",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10906",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10907",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10908",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10909",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10910",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10911",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10912",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10913",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10914",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10915",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10916",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10917",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10918",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10919",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10920",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10921",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10922",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10923",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10924",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10925",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10926",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10927",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10928",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10929",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10930",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10931",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10932",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10933",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10934",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10935",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10936",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10937",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10751",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10752",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10753",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10754",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10755",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10756",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10757",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10758",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10759",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10760",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10761",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10762",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10938",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10939",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "10940",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10941",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10942",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "10943",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10706",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10707",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10708",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10793",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10794",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10795",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10796",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10803",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10804",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10805",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10806",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10807",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10808",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7039",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10701",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10702",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11014",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11015",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11016",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11017",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11018",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11019",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11020",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11022",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11023",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11024",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11025",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11026",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11027",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11028",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11029",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11030",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11031",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11032",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11033",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11034",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11035",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11036",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11037",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11038",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11039",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11040",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11041",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11042",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11043",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11048",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11049",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11050",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11051",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11052",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11053",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10944",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10945",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10946",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10948",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10949",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10950",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10951",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10954",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10955",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10956",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10960",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10961",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10962",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10963",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10964",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10965",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10966",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10967",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10968",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10969",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10970",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10971",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10972",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10973",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10974",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10975",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10976",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11060",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11061",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11062",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11063",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11064",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11065",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11066",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11067",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11068",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11069",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11070",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11071",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11072",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11073",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11074",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11075",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11076",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11077",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11078",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11079",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11080",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11081",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11082",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11083",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10977",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10978",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10979",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10980",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10981",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10982",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10983",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10984",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10985",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10986",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10987",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10988",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10989",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10990",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10991",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10992",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10993",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10994",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10995",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10996",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11084",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11085",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11086",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11087",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11088",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11089",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11090",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11091",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11092",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11093",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10997",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "10998",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "10999",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11000",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11001",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11094",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11095",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11096",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11097",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11098",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11099",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11100",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11101",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11102",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11103",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11104",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11105",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11106",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11107",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11108",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11109",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11110",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11111",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11112",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11113",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11114",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11115",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11116",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11117",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11118",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11119",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11120",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11121",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11122",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11123",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11124",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11125",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11126",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11127",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11128",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11129",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11130",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11131",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11132",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11133",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11134",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11135",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11136",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11137",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11138",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11139",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11140",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11141",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11142",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11143",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11144",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11145",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11146",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11147",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11148",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11149",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11150",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11151",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11152",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11153",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11154",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11155",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11156",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11157",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11158",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11159",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11160",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11161",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11162",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11163",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11164",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11165",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11166",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11167",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11168",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11169",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11170",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11171",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11172",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11173",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11174",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11175",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11176",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11177",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11178",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11179",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11180",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11181",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11182",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11183",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11184",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11185",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11186",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11187",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11188",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11002",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11003",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11004",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11005",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11006",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11007",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11008",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11009",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11010",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11011",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11012",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11013",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11189",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11190",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11191",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11192",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11193",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11194",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10957",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10958",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "10959",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11044",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11045",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11046",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11047",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11054",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11055",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11056",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11057",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11058",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11059",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7046",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "10952",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "10953",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2614",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2615",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2616",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2617",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2618",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2619",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2620",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2621",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2622",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2623",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2624",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2625",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2626",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2627",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2628",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2629",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2630",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2631",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2632",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2633",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2634",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2635",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2636",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2637",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2638",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2639",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2640",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2641",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2642",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2643",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2648",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2649",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2650",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2651",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2652",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2653",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2544",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2545",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2546",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2547",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2548",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2549",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2550",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2551",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2554",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2555",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2556",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2560",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2561",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2562",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2563",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2564",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2565",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2566",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2567",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2568",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2569",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2570",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2571",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2572",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2573",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2574",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2575",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2576",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2660",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2661",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2662",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2663",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2664",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2665",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2666",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2667",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2668",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2669",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2670",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2671",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2672",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2673",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2674",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2675",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2676",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2677",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2678",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2679",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2680",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2681",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2682",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2683",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2577",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2578",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2579",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2580",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2581",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2582",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2583",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2584",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2585",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2586",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2587",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2588",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2589",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2590",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2591",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2592",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2593",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2594",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2595",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2596",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2684",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2685",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2686",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2687",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2688",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2689",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2690",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2691",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2692",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2693",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2597",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2598",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2599",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2600",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2601",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2694",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2695",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2696",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2697",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2698",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2699",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2700",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2701",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2702",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2703",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2704",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2705",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2706",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2707",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2708",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2709",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2710",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2711",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2712",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2713",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2714",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2715",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2716",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2717",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2718",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2719",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2720",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2721",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2722",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2723",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2724",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2725",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2726",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2727",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2728",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2729",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2730",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2731",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2732",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2733",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2734",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2735",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2736",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2737",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2738",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2739",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2740",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2741",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2742",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2743",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2744",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2745",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2746",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2747",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2748",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2749",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2750",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2751",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2752",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2753",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2754",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2755",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2756",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2757",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2758",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2759",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2760",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2761",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2762",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2763",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2764",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2765",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2766",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2767",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2768",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2769",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2771",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2772",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2773",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2774",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2775",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2776",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2777",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2778",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2779",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2780",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2781",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2782",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2783",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2784",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2785",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2786",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2787",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2788",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2602",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2603",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2604",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2605",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2606",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2607",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2608",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2609",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2610",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2611",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2612",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2613",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2789",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2790",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2791",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2792",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2793",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2794",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2557",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2558",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2559",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2644",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2645",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2646",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2647",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2654",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2655",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2656",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2657",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2658",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2659",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "710",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2552",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2553",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2865",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2866",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2867",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2868",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2869",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2870",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2871",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2872",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2873",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2874",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2875",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2876",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2877",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2878",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2879",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2880",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2881",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2882",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2883",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2884",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2885",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2886",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2887",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2888",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2889",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2890",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2891",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2892",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2893",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2894",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2899",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2900",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2901",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2902",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2903",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2904",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2795",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2796",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2797",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2798",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2799",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2800",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2801",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2802",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2805",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2806",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2807",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2811",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2812",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2813",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2814",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2815",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2816",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2817",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2818",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2819",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2820",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2821",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2822",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2823",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2824",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2825",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2826",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2827",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2911",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2912",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2913",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2914",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2915",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2916",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2917",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2918",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2919",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2920",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2921",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2922",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2923",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2924",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2925",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2926",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2927",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2928",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2929",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2930",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2931",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2932",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2933",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2934",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2828",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2829",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2830",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2831",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2832",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2833",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2834",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2835",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2836",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2837",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2838",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2839",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2840",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2841",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2842",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2843",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2844",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2845",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2846",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2847",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2935",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2936",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2937",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2938",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2939",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2940",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2941",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2942",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2943",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2944",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2848",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2849",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2850",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2851",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2852",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2945",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2946",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2947",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2948",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2949",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2950",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2951",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2952",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2953",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2954",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2955",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2956",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2957",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2958",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2959",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2960",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2961",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2962",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2963",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2964",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2965",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2966",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2967",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2968",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2969",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2970",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2971",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2972",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2973",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2974",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2975",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2976",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2977",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2978",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2979",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2980",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2981",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2982",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2983",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2984",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2985",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2986",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2987",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2988",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2989",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2990",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2991",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2992",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2993",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2994",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2995",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2996",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2997",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2998",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2999",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3000",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3001",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3002",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3003",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3004",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3005",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3006",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3007",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3008",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3009",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3010",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3011",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3012",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3013",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "3014",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "3015",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3016",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3017",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "3018",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3019",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3020",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3021",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3022",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3023",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "3024",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3025",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3026",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3027",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3028",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3029",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "3030",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3031",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3032",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3033",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3034",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3035",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "3036",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3037",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3038",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3039",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2853",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2854",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2855",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2856",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2857",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2858",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2859",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2860",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "2861",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2862",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2863",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "2864",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "3040",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3041",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "3042",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3043",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3044",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "3045",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2808",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2809",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "2810",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2895",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2896",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2897",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2898",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2905",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2906",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "2907",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2908",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2909",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "2910",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "711",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "2803",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "2804",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11265",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11266",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11267",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11268",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11269",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11270",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11271",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11272",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11273",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11274",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11275",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11276",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11277",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11278",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11279",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11280",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11281",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11282",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11283",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11284",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11285",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11286",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11287",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11289",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11290",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11291",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11292",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11293",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11299",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11300",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11301",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11302",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11303",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11304",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11195",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11197",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11198",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11199",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11201",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11202",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11205",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11206",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11207",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11211",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11212",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11213",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11214",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11215",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11216",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11217",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11218",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11219",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11220",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11221",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11222",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11223",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11224",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11225",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11226",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11227",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11311",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11312",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11313",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11314",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11315",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11316",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11317",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11318",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11319",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11320",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11321",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11322",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11323",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11324",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11325",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11326",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11327",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11328",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11329",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11330",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11331",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11332",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11333",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11334",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11228",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11229",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11230",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11231",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11232",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11233",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11234",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11235",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11236",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11237",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11238",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11239",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11240",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11241",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11242",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11243",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11244",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11245",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11246",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11247",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11335",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11336",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11337",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11338",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11339",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11340",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11341",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11342",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11343",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11344",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11248",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11249",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11250",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11251",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11252",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11345",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11346",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11347",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11348",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11349",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11350",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11351",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11352",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11353",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11354",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11355",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11356",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11357",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11358",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11359",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11360",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11361",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11362",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11363",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11364",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11365",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11366",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11367",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11368",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11369",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11370",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11371",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11372",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11373",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11374",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11375",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11376",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11377",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11378",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11379",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11380",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11381",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11382",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11383",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11384",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11385",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11386",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11387",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11388",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11389",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11390",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11391",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11392",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11393",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11394",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11395",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11396",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11397",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11398",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11399",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11400",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11401",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11402",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11403",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11404",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11405",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11406",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11407",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11408",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11409",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11410",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11411",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11412",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11413",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11414",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11415",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11416",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11417",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11418",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11419",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11420",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11421",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11422",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11423",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11424",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11425",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11426",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11427",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11428",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11429",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11430",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11431",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11432",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11433",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11434",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11435",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11436",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11437",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11438",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11439",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11253",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11254",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11255",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11256",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11257",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11258",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11259",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11260",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11261",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11262",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11263",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11440",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11441",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "11442",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11443",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11444",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "11445",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11208",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11209",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "11210",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11295",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11296",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11297",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11298",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11305",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11306",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "11307",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11308",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11309",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "11310",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "7146",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "11203",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "11204",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "675",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "676",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "677",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "678",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "679",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "680",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "681",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "682",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "683",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "684",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "685",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "686",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "687",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "688",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "689",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "690",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "691",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "693",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "624",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "625",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "626",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "627",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "628",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "629",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "630",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "631",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "634",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "635",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "636",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "637",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "642",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "643",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "644",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "645",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "646",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "647",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "648",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "650",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "651",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "652",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "653",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "654",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "655",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "656",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "657",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "658",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "659",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "660",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "661",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "662",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "663",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "695",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "696",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "697",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "698",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "699",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "700",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "701",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "702",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "664",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "665",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "666",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "667",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "703",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "704",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "668",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "705",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "706",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "707",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "708",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "709",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "710",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "711",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "712",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "713",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "714",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "715",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "716",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "717",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "718",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "719",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "720",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "721",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "722",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "723",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "724",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "725",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "726",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "727",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "728",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "729",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "730",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "731",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "732",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "733",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "734",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "735",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "736",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "737",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "738",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "739",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "669",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "670",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "671",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "672",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "673",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "674",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "740",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "741",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "742",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "C"
          },
          "sort_number": "638",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "B",
            "pwht": "C",
            "toughness": "D"
          },
          "sort_number": "639",
          "not_recommended": false
        },
        {
          "filler": "A356.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "A"
          },
          "sort_number": "640",
          "not_recommended": false
        },
        {
          "filler": "A357.0",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "C",
            "toughness": "B"
          },
          "sort_number": "641",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "692",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "694",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "A356.0",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "632",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "633",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4690",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4691",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4692",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4693",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4694",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4695",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4696",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4697",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4698",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4699",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4700",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4701",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4702",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4703",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4704",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4705",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4706",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4707",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4708",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4709",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4710",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4711",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4712",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4713",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4717",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4718",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4719",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4720",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4721",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4722",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4638",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4639",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4640",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4641",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4642",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4643",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4644",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4645",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4648",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4650",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4651",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4652",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4653",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4654",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4655",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4656",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4729",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4730",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4731",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4732",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4733",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4734",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4735",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4736",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4737",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4738",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4739",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4740",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4741",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4742",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4743",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4744",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4745",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4746",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4657",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4658",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4659",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4660",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4661",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4662",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4663",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4664",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4665",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4666",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4667",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4668",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4669",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4670",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4671",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4672",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4673",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4674",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4675",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4676",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4747",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4748",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4749",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4750",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4751",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4752",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4753",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4754",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4755",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4756",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4677",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4678",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4679",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4680",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4681",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4757",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4758",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4759",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4760",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4761",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4762",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4763",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4764",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4765",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4766",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4767",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4768",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4769",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4770",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4771",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4772",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4773",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4774",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4775",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4776",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4777",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4778",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4779",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4780",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4781",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4782",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4783",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4784",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4785",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4786",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4787",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4788",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4789",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4790",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4791",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4792",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4793",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4794",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4795",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4796",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4797",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4798",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4799",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4800",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4801",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4802",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4803",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4804",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4805",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4806",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4807",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4808",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4809",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4810",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4811",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4812",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4813",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4814",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4815",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4816",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4817",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4818",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4819",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4820",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4821",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4822",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4823",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4824",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4825",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4826",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4827",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4828",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4829",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4830",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4831",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4832",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4833",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4834",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4835",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4836",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4837",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4838",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4839",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4840",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4682",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4683",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4684",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4685",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4686",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4687",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4688",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4689",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4841",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4842",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4843",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4844",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4649",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "B",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4714",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4715",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4716",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4723",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4724",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4725",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4726",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "4727",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "4728",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3003",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "4646",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "4647",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5138",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5139",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5140",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5141",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5142",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5143",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5144",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5145",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5146",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5147",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5148",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5149",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5150",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5151",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5152",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5153",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5154",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5155",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5156",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5157",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5158",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5159",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5160",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5161",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "D",
            "strength": "D",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5162",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5163",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5164",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5165",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5166",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5167",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5168",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5169",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "5170",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5171",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5172",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5173",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5174",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5175",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5176",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "D",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5183",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5184",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5185",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5186",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5187",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "319",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5082",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5083",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "333",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5084",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5085",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "354",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5086",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5087",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "355",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5088",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5089",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5092",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5094",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5095",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "380",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5096",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5097",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5098",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5099",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5100",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5193",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5194",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5195",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5196",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5197",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5198",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5199",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5200",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5201",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5202",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5203",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5204",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5205",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5206",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5207",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5208",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5209",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5210",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "511",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5101",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5102",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5103",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5104",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5105",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "512",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5106",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5107",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5108",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5109",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5110",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "513",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5111",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5112",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5113",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5114",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5115",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "514",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5116",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5117",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5118",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5119",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5120",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5211",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5212",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5213",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5214",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5215",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5216",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5217",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5218",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5219",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5220",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "535",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5121",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5122",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5123",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5124",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5125",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5221",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5222",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5223",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5224",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5225",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5226",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5227",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "5183",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5228",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5229",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5230",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5231",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5232",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5233",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5234",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5235",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5236",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5237",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5238",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5239",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5240",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5241",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5242",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5243",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5244",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5245",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5246",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5247",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5248",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5249",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5250",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5251",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5252",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5253",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5254",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5255",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5256",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5257",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5258",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5259",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5260",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5261",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5262",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5263",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5264",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5265",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5266",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5267",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5268",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5269",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5270",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5271",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5272",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5273",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5274",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5275",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5276",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5277",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5278",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5279",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5280",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5281",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5282",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5283",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5284",
          "not_recommended": false
        },
        {
          "filler": "4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5285",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5286",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5287",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5288",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5289",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5290",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5291",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5292",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5293",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5294",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5295",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5296",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5297",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5298",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5299",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5300",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5301",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5302",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5303",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5304",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5305",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5306",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5307",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5308",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5309",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5310",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5311",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5312",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5126",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5127",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5128",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5129",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5130",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5131",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5132",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5133",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5134",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5135",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5136",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5137",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5313",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5314",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5315",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5316",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5317",
          "not_recommended": false
        },
        {
          "filler": "5654",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "",
            "color": "B",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5318",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5093",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "1100",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5177",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "C",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5178",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "B",
            "strength": "C",
            "ductility": "D",
            "corrosion": "B",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5179",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "C",
            "strength": "A",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5180",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "C",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5181",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "C",
            "strength": "",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5182",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "D",
            "ductility": "D",
            "corrosion": "A",
            "temperature": "A",
            "color": "",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5188",
          "not_recommended": false
        },
        {
          "filler": "5183",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5189",
          "not_recommended": false
        },
        {
          "filler": "5356",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "A"
          },
          "sort_number": "5190",
          "not_recommended": false
        },
        {
          "filler": "5554",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "A",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5191",
          "not_recommended": false
        },
        {
          "filler": "5556",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "C",
            "corrosion": "C",
            "temperature": "",
            "color": "A",
            "pwht": "",
            "toughness": "B"
          },
          "sort_number": "5192",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "Alclad 3004",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "5090",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "5091",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "1060",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "439",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "440",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "1070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "441",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "442",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "1080",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "443",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "444",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "1100",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "445",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "446",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "1350",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "447",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "448",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "2014",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "449",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "450",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "451",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "2036",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "452",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "453",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "454",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "2219",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "455",
          "not_recommended": false
        },
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "C",
            "strength": "C",
            "ductility": "B",
            "corrosion": "C",
            "temperature": "A",
            "color": "A",
            "pwht": "B",
            "toughness": "C"
          },
          "sort_number": "456",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "B",
            "ductility": "C",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "457",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "458",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "459",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "462",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "463",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "319",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "404",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "405",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "333",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "406",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "407",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "354",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "408",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "409",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "355",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "410",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "411",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "356",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "414",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "415",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "357",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "418",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "419",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "359",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "420",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "421",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "380",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "422",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "423",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "413",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "424",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "425",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "443",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "426",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "427",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "444",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "428",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "429",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "466",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5050",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "467",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5052",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "468",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5083",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "469",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5086",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "470",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "511",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "430",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "512",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "431",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "513",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "432",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "514",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "433",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5154",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "471",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5254",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "472",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "535",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "434",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5383",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "473",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5454",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "474",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5456",
      "options": [
        {
          "filler": "NOT RECCOMMENDED",
          "properties": {
            "cracking": "",
            "strength": "",
            "ductility": "",
            "corrosion": "",
            "temperature": "",
            "color": "",
            "pwht": "",
            "toughness": ""
          },
          "sort_number": "475",
          "not_recommended": true
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "5652",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "476",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "477",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "478",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6061",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "479",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "480",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6063",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "481",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "482",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6070",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "483",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "484",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6082",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "485",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "486",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6151",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "487",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "488",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6201",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "489",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "490",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6351",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "491",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "492",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "6951",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "493",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "494",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "7005",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "495",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "496",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "7021",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "497",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "498",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "7039",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "499",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "500",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "7046",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "501",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "502",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "710",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "435",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "436",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "711",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "437",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "438",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "7146",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "503",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "504",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "A356.0",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "416",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "417",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "Alclad 3003",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "460",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "461",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "Alclad 3004",
      "options": [
        {
          "filler": "4043/4943**",
          "properties": {
            "cracking": "B",
            "strength": "B",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "C"
          },
          "sort_number": "464",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "A",
            "ductility": "B",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "",
            "toughness": "D"
          },
          "sort_number": "465",
          "not_recommended": false
        }
      ]
    },
    {
      "alloy_a": "C355.0",
      "alloy_b": "C355.0",
      "options": [
        {
          "filler": "2319",
          "properties": {
            "cracking": "B",
            "strength": "A",
            "ductility": "A",
            "corrosion": "A",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "A"
          },
          "sort_number": "412",
          "not_recommended": false
        },
        {
          "filler": "4145",
          "properties": {
            "cracking": "A",
            "strength": "C",
            "ductility": "B",
            "corrosion": "B",
            "temperature": "A",
            "color": "A",
            "pwht": "A",
            "toughness": "D"
          },
          "sort_number": "413",
          "not_recommended": false
        }
      ]
    }
  ]
}